(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["price"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wjd-flash-deal')) {
    customElements.define('wjd-flash-deal', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const trigger = this.querySelector('.wjd-flash-trigger');
        const dialog = this.querySelector('dialog');
        trigger.addEventListener('click', () => dialog.showModal());
        dialog.addEventListener('click', (event) => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sub-collections-list"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wjd-collection-shortcuts')) {
      customElements.define('wjd-collection-shortcuts', class extends HTMLElement {
        static greeted = new Set();
        connectedCallback() {
          if (this.controller) return;
          this.track = this.querySelector('.wjd-shortcut-track');
          this.buttons = Array.from(this.querySelectorAll('[data-step]'));
          if (!this.track) return;
          this.controller = new AbortController();
          const options = { signal: this.controller.signal };
          const refresh = () => this.update();
          this.addEventListener('error', event => {
            if (event.target.matches?.('img.wjd-shortcut-image')) event.target.remove();
          }, { ...options, capture: true });
          this.track.addEventListener('scroll', refresh, { ...options, passive: true });
          this.buttons.forEach(button => button.addEventListener('click', () => {
            const direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
            this.track.scrollBy({left: Number(button.dataset.step) * direction * this.track.clientWidth * .8, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
          }, options));
          this.track.addEventListener('focusin', event => {
            const target = event.target.closest('a');
            if (!target) return;
            const box = target.getBoundingClientRect();
            const view = this.track.getBoundingClientRect();
            if (box.left < view.left) this.track.scrollBy({left:box.left-view.left-2,behavior:'auto'});
            else if (box.right > view.right) this.track.scrollBy({left:box.right-view.right+2,behavior:'auto'});
          }, options);
          this.observer = new ResizeObserver(refresh);
          this.observer.observe(this);
          this.observer.observe(this.track);
          if (document.fonts) document.fonts.ready.then(() => { if (this.isConnected) this.update(); });
          this.update();
          this.setupDiscovery();
        }

        setupDiscovery() {
          this.introPreference = matchMedia('(prefers-reduced-motion: reduce)');
          const signal = this.controller.signal;
          const stop = () => this.cancelDiscovery(true);
          ['pointerdown', 'touchstart', 'wheel', 'keydown', 'focusin'].forEach(type => {
            this.addEventListener(type, stop, { capture: true, passive: true, signal });
          });
          this.introPreference.addEventListener('change', () => {
            if (this.introPreference.matches) stop();
          }, { signal });
          if (this.introPreference.matches || !('IntersectionObserver' in window)) return;
          this.introObserver = new IntersectionObserver(entries => {
            if (!entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= .6)) return;
            this.introObserver.disconnect();
            this.introFrame = requestAnimationFrame(() => {
              this.introFrame = null;
              this.playDiscovery();
            });
          }, { threshold: .6 });
          const ready = () => {
            if (this.isConnected && !signal.aborted && !this.introDone) this.introObserver.observe(this);
          };
          if (document.fonts) document.fonts.ready.then(ready);
          else ready();
        }
        playDiscovery() {
          if (this.introDone || !this.isConnected || this.introPreference.matches || this.contains(document.activeElement)) return;
          this.introDone = true;
          const distance = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
          const belt = this.querySelector('.wjd-shortcut-belt');
          if (distance < 24 || Math.abs(this.track.scrollLeft) > 1 || typeof belt?.animate !== 'function') return;
          const key = location.pathname;
          if (this.constructor.greeted.has(key)) return;
          this.constructor.greeted.add(key);
          this.introBelt = belt;
          const direction = getComputedStyle(this).direction === 'rtl' ? 1 : -1;
          const start = 'translateX(' + direction * distance + 'px)';
          try {
            const motion = belt.animate([
              { transform: start, offset: 0 },
              { transform: start, offset: .1 },
              { transform: 'translateX(0)', offset: 1 }
            ], { duration: Math.min(1000, Math.max(650, distance * .55)), easing: 'cubic-bezier(.22,.61,.36,1)' });
            this.introMotion = motion;
            motion.finished.then(() => {
              if (this.introMotion === motion) this.cancelDiscovery(false);
            }, () => {});
          } catch (error) {
            this.introMotion = null;
          }
        }
        cancelDiscovery(preservePosition) {
          this.introDone = true;
          if (this.introFrame) cancelAnimationFrame(this.introFrame);
          this.introFrame = null;
          this.introObserver?.disconnect();
          const motion = this.introMotion;
          this.introMotion = null;
          if (!motion) return;
          let position = null;
          if (preservePosition && this.isConnected && this.introBelt) {
            try {
              position = -new DOMMatrixReadOnly(getComputedStyle(this.introBelt).transform).m41;
            } catch (error) {}
          }
          motion.cancel();
          if (Number.isFinite(position)) this.track.scrollTo({ left: position, behavior: 'instant' });
        }
        update() {
          const required = this.track.scrollWidth > this.clientWidth + 2;
          this.toggleAttribute('data-overflow', required);
          const max = this.track.scrollWidth - this.track.clientWidth;
          const position = Math.abs(this.track.scrollLeft);
          this.toggleAttribute('data-at-end', position >= max - 2);
          this.buttons.forEach(button => {
            button.hidden = !required;
            button.disabled = Number(button.dataset.step) < 0 ? position <= 2 : position >= max - 2;
          });
        }
        disconnectedCallback() {
          this.cancelDiscovery(false);
          this.controller?.abort();
          this.observer?.disconnect();
          this.controller = null;
        }
      });
    }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wjd-boost-card-galleries"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wjd-boost-card-galleries')) {
  class WjdBoostGallery {
    constructor(card, moreText) {
      this.card = card;
      this.track = card.querySelector(
        '.boost-sd__product-image-wrapper > a.boost-sd__product-image'
      );
      this.host = this.track?.parentElement;

      if (!this.track || !this.track.querySelector('img')) return;

      this.events = new AbortController();
      this.current = 0;
      this.moreText = moreText;

      this.host.classList.remove('shoptimizer-plp-carousel-container');
      this.track.classList.remove('shoptimizer-plp-image-wrapper');

      this.host.classList.add('wjd-boost-gallery');
      this.track.classList.add('wjd-boost-track');

      this.host.querySelector(':scope > .wjd-boost-dots')?.remove();

      this.dots = document.createElement('div');
      this.dots.className = 'wjd-boost-dots';
      this.host.append(this.dots);

      this.refresh();

      const options = { signal: this.events.signal };

      this.track.addEventListener(
        'scroll',
        () => this.scheduleUpdate(),
        { ...options, passive: true }
      );

      this.track.addEventListener(
        'keydown',
        event => this.keydown(event),
        options
      );

      this.track.addEventListener(
        'dragstart',
        event => event.preventDefault(),
        options
      );

      this.track.addEventListener('pointerdown', event => {
        if (!event.isPrimary || event.button !== 0) return;

        this.pointer = {
          id: event.pointerId,
          type: event.pointerType,
          x: event.clientX,
          y: event.clientY,
          left: this.track.scrollLeft,
          dragged: false
        };

        this.suppressUntil = 0;
      }, options);

      this.track.addEventListener('pointermove', event => {
        const pointer = this.pointer;

        if (!pointer || pointer.id !== event.pointerId) return;

        const dx = event.clientX - pointer.x;
        const dy = event.clientY - pointer.y;

        if (
          !pointer.dragged &&
          Math.abs(dx) > 8 &&
          Math.abs(dx) > Math.abs(dy) * 1.2
        ) {
          pointer.dragged = true;

          if (pointer.type === 'mouse') {
            this.track.setPointerCapture(event.pointerId);
            this.track.classList.add('wjd-boost-dragging');
          }
        }

        if (pointer.dragged && pointer.type === 'mouse') {
          event.preventDefault();
          this.track.scrollLeft = pointer.left - dx;
        }
      }, options);

      const finish = event => {
        const pointer = this.pointer;

        if (!pointer || pointer.id !== event.pointerId) return;

        this.pointer = null;
        this.track.classList.remove('wjd-boost-dragging');

        if (!pointer.dragged) return;

        this.suppressUntil = performance.now() + 400;

        if (pointer.type === 'mouse') {
          this.go(this.nearest());

          if (this.track.hasPointerCapture(event.pointerId)) {
            this.track.releasePointerCapture(event.pointerId);
          }
        }
      };

      this.track.addEventListener('pointerup', finish, options);
      this.track.addEventListener('pointercancel', finish, options);
      this.track.addEventListener('lostpointercapture', finish, options);

      this.track.addEventListener('click', event => {
        if (
          performance.now() < (this.suppressUntil || 0) ||
          this.pointer?.dragged
        ) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, { ...options, capture: true });

      this.trackObserver = new MutationObserver(records => {
        if (
          records.some(record =>
            record.type === 'childList' ||
            record.target.tagName === 'IMG'
          )
        ) {
          this.scheduleRefresh();
        }
      });

      this.trackObserver.observe(this.track, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class', 'hidden']
      });

      this.resizeObserver = new ResizeObserver(() => {
        this.refresh();
        this.go(this.current, false);
      });

      this.resizeObserver.observe(this.host);
    }

    refresh() {
      for (const image of this.track.querySelectorAll(':scope > img')) {
        if (!image.classList.contains('wjd-boost-slide')) {
          image.classList.add('wjd-boost-slide');
        }

        image.draggable = false;
      }

      let more = this.track.querySelector(
        ':scope > .wjd-boost-more, :scope > .hide-up'
      );

      if (!more) {
        more = document.createElement('span');
        this.track.append(more);
      }

      if (!more.classList.contains('wjd-boost-more')) {
        more.removeAttribute('style');
        more.classList.remove('hide-up', 'dd');
        more.classList.add('wjd-boost-slide', 'wjd-boost-more');
        more.replaceChildren(document.createTextNode(this.moreText));

        const svg = document.createElementNS(
          'http://www.w3.org/2000/svg',
          'svg'
        );

        svg.setAttribute('viewBox', '0 0 24 24');
        svg.setAttribute('fill', 'none');
        svg.setAttribute('aria-hidden', 'true');

        const path = document.createElementNS(svg.namespaceURI, 'path');

        path.setAttribute('d', 'M5 12h14m-6-6 6 6-6 6');
        path.setAttribute('stroke', 'currentColor');
        path.setAttribute('stroke-width', '1.5');
        path.setAttribute('stroke-linecap', 'round');
        path.setAttribute('stroke-linejoin', 'round');

        svg.append(path);
        more.append(svg);
      }

      this.slides = [...this.track.children].filter(node =>
        node.classList.contains('wjd-boost-slide') &&
        getComputedStyle(node).display !== 'none'
      );

      if (this.buttons?.length !== this.slides.length) {
        this.dots.replaceChildren();

        this.buttons = this.slides.map((slide, index) => {
          const button = document.createElement('button');

          button.type = 'button';
          button.setAttribute(
            'aria-label',
            slide === more
              ? this.moreText
              : this.track.getAttribute('aria-label') + ': ' + (index + 1)
          );

          button.append(document.createElement('span'));

          button.addEventListener('click', event => {
            event.preventDefault();
            event.stopPropagation();
            this.go(index);
          }, { signal: this.events.signal });

          button.addEventListener(
            'keydown',
            event => this.keydown(event, true),
            { signal: this.events.signal }
          );

          this.dots.append(button);

          return button;
        });
      }

      this.dots.hidden = this.slides.length < 2;

      this.current = Math.min(
        this.current,
        Math.max(0, this.slides.length - 1)
      );

      this.paint(this.current);
    }

    nearest() {
      if (!this.slides?.length || !this.track.clientWidth) return 0;

      return Math.max(
        0,
        Math.min(
          this.slides.length - 1,
          Math.round(this.track.scrollLeft / this.track.clientWidth)
        )
      );
    }

    paint(index) {
      this.current = index;

      this.buttons?.forEach((button, number) => {
        if (number === index) {
          button.setAttribute('aria-current', 'true');
        } else {
          button.removeAttribute('aria-current');
        }
      });
    }

    go(index, animate = true) {
      const slide = this.slides[index];

      if (!slide) return;

      const reduced = matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      this.track.scrollTo({
        left: slide.offsetLeft - this.slides[0].offsetLeft,
        behavior: animate && !reduced ? 'smooth' : 'instant'
      });

      this.paint(index);
    }

    keydown(event, fromDots = false) {
      if (
        !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)
      ) return;

      event.preventDefault();
      event.stopPropagation();

      let index = fromDots
        ? this.buttons.indexOf(event.currentTarget)
        : this.nearest();

      if (event.key === 'Home') {
        index = 0;
      } else if (event.key === 'End') {
        index = this.slides.length - 1;
      } else {
        index += event.key === 'ArrowRight' ? 1 : -1;
      }

      index = Math.max(0, Math.min(this.slides.length - 1, index));

      this.go(index);

      if (fromDots) {
        this.buttons[index]?.focus({ preventScroll: true });
      }
    }

    scheduleUpdate() {
      if (this.scrollFrame) return;

      this.scrollFrame = requestAnimationFrame(() => {
        this.scrollFrame = 0;
        this.paint(this.nearest());
      });
    }

    scheduleRefresh() {
      if (this.refreshFrame) return;

      this.refreshFrame = requestAnimationFrame(() => {
        this.refreshFrame = 0;
        this.refresh();
        this.go(0, false);
      });
    }

    destroy() {
      this.events?.abort();
      this.trackObserver?.disconnect();
      this.resizeObserver?.disconnect();

      cancelAnimationFrame(this.scrollFrame);
      cancelAnimationFrame(this.refreshFrame);
    }
  }

  customElements.define(
    'wjd-boost-card-galleries',
    class extends HTMLElement {
      connectedCallback() {
        if (this.observer) return;

        this.entries = new Map();
        this.pending = new Set();
        this.root = document.getElementById('MainContent');

        if (!this.root) return;

        const scan = node => {
          if (!(node instanceof Element)) return;

          const parentCard = node.closest(
            '.boost-sd__product-item[data-product]'
          );

          if (parentCard) this.pending.add(parentCard);

          node.querySelectorAll(
            '.boost-sd-right .boost-sd__product-item[data-product]'
          ).forEach(card => this.pending.add(card));

          if (this.frame) return;

          this.frame = requestAnimationFrame(() => {
            this.frame = 0;

            for (const card of this.pending) {
              if (
                !card.isConnected ||
                card.classList.contains('wjd-collection-tile') ||
                !card.closest('.boost-sd-right')
              ) continue;

              const track = card.querySelector(
                '.boost-sd__product-image-wrapper > a.boost-sd__product-image'
              );

              const previous = this.entries.get(card);

              if (
                previous?.track === track &&
                track?.isConnected
              ) continue;

              previous?.destroy();

              const gallery = new WjdBoostGallery(
                card,
                this.dataset.more
              );

              if (gallery.events) {
                this.entries.set(card, gallery);
              }
            }

            this.pending.clear();

            for (const [card, gallery] of this.entries) {
              if (!card.isConnected) {
                gallery.destroy();
                this.entries.delete(card);
              }
            }
          });
        };

        this.observer = new MutationObserver(records => {
          for (const record of records) {
            if (
              record.type === 'attributes' &&
              record.attributeName === 'class'
            ) {
              if (record.target.matches('.boost-sd__image-toggle-btn')) {
                this.entries.forEach(gallery => gallery.scheduleRefresh());
              }

              continue;
            }

            scan(record.target);

            for (const node of record.addedNodes) {
              scan(node);
            }
          }
        });

        this.observer.observe(this.root, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['data-product', 'class']
        });

        scan(this.root);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.observer = null;

        cancelAnimationFrame(this.frame);

        this.entries?.forEach(gallery => gallery.destroy());
        this.entries?.clear();
      }
    }
  );
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wjd-coupon-price"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('wjd-coupon-price')) return;
    let dialogIndex = 0;
    customElements.define('wjd-coupon-price', class extends HTMLElement {
      connectedCallback() {
        this.updateInternationalPrice();
        if (this.offerEvents || !this.classList.contains('wjd-coupon-price--product')) return;
        const fallback = this.querySelector('[data-wjd-offer-fallback]');
        const panel = this.querySelector('[data-wjd-offer-panel]');
        const trigger = this.querySelector('[data-wjd-offer-open]');
        const fallbackLabel = this.querySelector('[data-wjd-offer-label]');
        const close = this.querySelector('[data-wjd-offer-close]');
        if (!panel || !trigger || !close || typeof HTMLDialogElement === 'undefined' || !HTMLDialogElement.prototype.showModal) return;
        const dialog = this.offerDialog || document.createElement('dialog');
        if (!this.offerDialog) {
          dialog.className = 'wjd-coupon-dialog';
          dialog.id = 'WjdCouponDialog-' + (++dialogIndex);
          dialog.setAttribute('aria-label', this.dataset.detailsLabel);
          dialog.append(panel);
          this.append(dialog);
          this.offerDialog = dialog;
        }
        if (fallback) fallback.hidden = true;
        if (fallbackLabel) fallbackLabel.hidden = true;
        trigger.hidden = false;
        trigger.setAttribute('aria-controls', dialog.id);
        close.hidden = false;
        this.offerEvents = new AbortController();
        const options = {signal:this.offerEvents.signal};
        trigger.addEventListener('click', () => {
          if (!dialog.open && this.isConnected) {
            dialog.showModal();
            close.focus({preventScroll:true});
          }
        }, options);
        close.addEventListener('click', () => dialog.close(), options);
        dialog.addEventListener('close', () => { if (trigger.isConnected) trigger.focus({preventScroll:true}); }, options);
        dialog.addEventListener('click', (event) => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        }, options);
      }
      static fixedSaving(price, rate, currency) {
        if (!Number.isFinite(price) || price <= 0 || !Number.isFinite(rate) || rate <= 0) return 0;
        try {
          const digits = new Intl.NumberFormat('en', {style:'currency', currency}).resolvedOptions().maximumFractionDigits;
          const step = 100 / Math.pow(10, digits);
          return Math.min(price, Math.round(50000 * rate / step) * step);
        } catch {
          return 0;
        }
      }
      updateInternationalPrice() {
        if (this.dataset.currency === 'USD' || this.dataset.watchEligible !== 'true') return;
        const currency = window.Shopify?.currency;
        if (currency?.active !== this.dataset.currency) return;
        const price = Number(this.dataset.price);
        const saving = this.constructor.fixedSaving(price, Number(currency.rate), currency.active);
        if (!saving) return;
        let format;
        try {
          format = new Intl.NumberFormat(document.documentElement.lang || 'en', {
            style:'currency', currency:currency.active,
            currencyDisplay:this.dataset.currencyCode === 'true' ? 'code' : 'symbol'
          });
        } catch {
          return;
        }
        const digits = format.resolvedOptions().maximumFractionDigits;
        const step = 100 / Math.pow(10, digits);
        const percentageSaving = Math.round(price * .05 / step) * step;
        if (saving <= percentageSaving) return;
        const money = amount => format.format(amount / 100);
        const total = price - saving;
        const label = this.dataset.withTemplate.replace('[code]', 'WATCH500');
        this.dataset.wjdCouponPrice = String(total);
        this.dataset.wjdOfferCode = 'WATCH500';
        this.querySelector('.wjd-coupon-price__amount').textContent = this.dataset.fromTemplate
          ? this.dataset.fromTemplate.replace('[price]', money(total))
          : money(total);
        this.querySelectorAll('.wjd-coupon-price__label').forEach(node => { node.textContent = label; });
        this.querySelector('.wjd-coupon-price__limit').textContent = this.dataset.watchLimit;
        const panel = this.querySelector('[data-wjd-offer-panel]');
        if (!panel) return;
        panel.querySelector('.wjd-coupon-price__breakdown').hidden = false;
        panel.querySelector('.wjd-coupon-price__code').textContent = 'WATCH500';
        panel.querySelector('.wjd-coupon-price__row--saving dd').textContent = '\u2212' + money(saving);
        panel.querySelector('.wjd-coupon-price__row--total dt').textContent = label;
        panel.querySelector('.wjd-coupon-price__row--total dd').textContent = money(total);
        panel.querySelector('.wjd-coupon-price__terms p').textContent = this.dataset.watchTerms;
        this.querySelector('[data-wjd-offer-open]').setAttribute('aria-label', this.dataset.detailsLabel + ': WATCH500');
      }
      disconnectedCallback() {
        if (this.offerDialog?.open) this.offerDialog.close();
        this.offerEvents?.abort();
        this.offerEvents = null;
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wjd-delight-motion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wjd-delight-motion')) {
  customElements.define('wjd-delight-motion', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const signal = this.events.signal;

      this.reduced = matchMedia('(prefers-reduced-motion:reduce)');
      this.reduced.addEventListener('change', () => this.sync(), { signal });
      document.addEventListener('visibilitychange', () => this.sync(), { signal });

      const ready = () => Promise.resolve(document.fonts?.ready).then(() => {
        if (signal.aborted) return;
        this.timer = setTimeout(() => {
          if (signal.aborted) return;
          this.frame = requestAnimationFrame(() => this.setup());
        }, 1000);
      });

      if (document.readyState === 'complete') ready();
      else window.addEventListener('load', ready, { once: true, signal });
    }

    setup() {
      if (!this.isConnected || !('IntersectionObserver' in window)) return;

      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          entry.target.classList.toggle(
            'wjd-delight-visible',
            entry.isIntersecting && entry.intersectionRatio >= .5
          );
        });
      }, { threshold: [0, .5] });

      const targets = [
        ['plus', 'wjd-navigation .wn-mobile>span:last-child'],
        ['stars', '.wh-home .wh-rating'],
        ['yours', '.wh-home .wh-yours'],
        ['hero', '.wh-home .wh-hero,.wh-home .wh-watch--lead'],
        ['footer', '#wjd-footer .wh-footer-brand>a>img']
      ];

      this.targets = [];
      this.added = [];
      this.manual = new Map();
      this.lastPlay = new WeakMap();

      targets.forEach(([name, selector]) => {
        document.querySelectorAll(selector).forEach(target => {
          target.dataset.wjdDelight = name;

          if (name === 'hero' && target.matches('.wh-watch--lead')) {
            const sheen = document.createElement('span');
            sheen.className = 'wh-banner-sheen';
            sheen.setAttribute('aria-hidden', 'true');
            target.append(sheen);
            this.added.push(sheen);
          }

          if (['hero', 'footer'].includes(name)) this.bindAccent(target, name);

          if (name === 'stars') {
            target.querySelectorAll('.wh-stars-base>svg,.wh-stars-fill>svg')
              .forEach((star, index) => {
                star.style.setProperty('--wjd-star-order', index % 5);
              });
          }

          this.targets.push(target);
          this.observer.observe(target);
        });
      });

      document.querySelectorAll('.header .header__heading-logo-wrapper').forEach(target => {
        this.bindAccent(target, 'header');
      });

      this.started = true;
      this.sync();
    }

    bindAccent(target, name) {
      const signal = this.events.signal;
      let start = null;
      let suppressUntil = 0;
      const play = () => this.playAccent(target, name);

      target.addEventListener('pointerenter', event => {
        if (event.pointerType !== 'touch') play();
      }, { signal, passive: true });
      target.addEventListener('pointerdown', event => {
        if (!event.isPrimary || event.button !== 0) return;
        start = { id: event.pointerId, x: event.clientX, y: event.clientY };
      }, { signal, passive: true });
      target.addEventListener('pointermove', event => {
        if (!start || event.pointerId !== start.id) return;
        const x = Math.abs(event.clientX - start.x);
        const y = Math.abs(event.clientY - start.y);
        if (y > 18 && y > x) start = null;
        else if (x > 18 && x > y * 1.4) {
          start = null;
          suppressUntil = performance.now() + 800;
          play();
        }
      }, { signal, passive: true });
      target.addEventListener('pointerup', () => { start = null; }, { signal, passive: true });
      target.addEventListener('pointercancel', () => { start = null; }, { signal, passive: true });
      target.addEventListener('click', event => {
        if (performance.now() < suppressUntil) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }
        if (name === 'yours') play();
      }, { signal, capture: true });
      if (name === 'yours') target.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          play();
        }
      }, { signal });
    }

    playAccent(target, name) {
      if (document.hidden || this.reduced.matches) return;
      const now = performance.now();
      if (now - (this.lastPlay.get(target) ?? -Infinity) < 2500) return;
      this.lastPlay.set(target, now);
      if (name === 'header') {
        document.querySelector('wjd-brand-moment')?.dispatchEvent(new Event('wjd-brand-play'));
        return;
      }
      const animate = (element, frames, duration) => {
        if (!element) return;
        this.manual.get(element)?.cancel();
        const motion = element.animate(frames, { duration, easing: 'ease-in-out' });
        this.manual.set(element, motion);
        motion.finished.then(() => {
          if (this.manual.get(element) === motion) this.manual.delete(element);
        }, () => {});
      };
      if (name === 'hero') {
        animate(target.querySelector('.wh-hero-sheen,.wh-banner-sheen'), [
          { transform: 'translateX(-120%)', opacity: 0 },
          { opacity: .7, offset: .16 },
          { transform: 'translateX(120%)', opacity: .7, offset: .88 },
          { transform: 'translateX(120%)', opacity: 0 }
        ], 3400);
      } else {
        animate(target, [
          { transform: 'rotate(0) scale(1)' },
          { transform: 'rotate(-3deg) scale(1.025)', offset: .35 },
          { transform: 'rotate(1deg) scale(1)', offset: .68 },
          { transform: 'rotate(0) scale(1)' }
        ], 950);
        if (name === 'yours') animate(target.querySelector('.wh-yours-ink'), [
          { transform: 'scaleX(0)', opacity: 0 },
          { transform: 'scaleX(1)', opacity: .65, offset: .4 },
          { transform: 'scaleX(1)', opacity: .65, offset: .8 },
          { transform: 'scaleX(1)', opacity: 0 }
        ], 1400);
      }
    }

    sync() {
      if (document.hidden || this.reduced.matches) {
        this.manual?.forEach(motion => motion.cancel());
        this.manual?.clear();
      }
      document.documentElement.toggleAttribute(
        'data-wjd-delight-ready',
        Boolean(this.started && !document.hidden && !this.reduced.matches)
      );
    }

    disconnectedCallback() {
      this.events?.abort();
      this.events = null;
      clearTimeout(this.timer);
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.manual?.forEach(motion => motion.cancel());
      this.added?.forEach(element => element.remove());
      document.documentElement.removeAttribute('data-wjd-delight-ready');

      this.targets?.forEach(target => {
        if (target.dataset.wjdDelight === 'yours') {
          target.removeAttribute('role');
          target.removeAttribute('tabindex');
        }
        delete target.dataset.wjdDelight;
        target.classList.remove('wjd-delight-visible');
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wjd-delivery-estimate"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wjd-delivery-estimate')) {
  class WjdDeliveryEstimate extends HTMLElement {
    connectedCallback() {
      this.refresh();
      this.timer = setInterval(() => this.refresh(), 60000);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({data}) => {
          if (String(data.sectionId) !== this.dataset.section) return;
          const fresh = data.html?.getElementById(this.id);
          if (fresh) this.replaceWith(fresh.cloneNode(true));
          else this.querySelector('[data-estimate]').hidden = true;
        });
        this.unsubscribeOptions = subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, ({data}) => {
          if (this.closest('product-info')?.contains(data.event.target)) this.querySelector('[data-estimate]').hidden = true;
        });
      }
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.unsubscribe?.();
      this.unsubscribeOptions?.();
    }
    static businessDay(date) {
      const day = date.getUTCDay(), month = date.getUTCMonth(), n = date.getUTCDate(), year = date.getUTCFullYear();
      if (day === 0 || day === 6) return false;
      const observed = (m, d, y = year) => {
        const holiday = new Date(Date.UTC(y, m, d));
        if (holiday.getUTCDay() === 6) holiday.setUTCDate(holiday.getUTCDate() - 1);
        if (holiday.getUTCDay() === 0) holiday.setUTCDate(holiday.getUTCDate() + 1);
        return holiday.toISOString().slice(0, 10) === date.toISOString().slice(0, 10);
      };
      if (observed(0,1) || observed(0,1,year+1) || observed(5,19) || observed(6,4) || observed(10,11) || observed(11,25)) return false;
      if (day === 1 && ((month === 0 && n >= 15 && n <= 21) || (month === 1 && n >= 15 && n <= 21) || (month === 4 && n >= 25) || (month === 8 && n <= 7) || (month === 9 && n >= 8 && n <= 14))) return false;
      return !(month === 10 && day === 4 && n >= 22 && n <= 28);
    }
    static arrival(now, days) {
      const parts = Object.fromEntries(new Intl.DateTimeFormat('en-US', {timeZone:'America/New_York',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',hourCycle:'h23'}).formatToParts(now).map(p => [p.type,p.value]));
      const date = new Date(Date.UTC(+parts.year,+parts.month-1,+parts.day));
      if (+parts.hour >= 9) date.setUTCDate(date.getUTCDate()+1);
      while (!this.businessDay(date)) date.setUTCDate(date.getUTCDate()+1);
      for (let remaining = days + 1; remaining > 0;) {
        date.setUTCDate(date.getUTCDate()+1);
        if (this.businessDay(date)) remaining--;
      }
      return date;
    }
    refresh() {
      const estimate = this.querySelector('[data-estimate]');
      if (!estimate) return;
      const days = Number(this.dataset.days);
      const allowed = this.dataset.available === 'true' && this.dataset.country === 'US' && [1,2,3].includes(days);
      estimate.hidden = !allowed;
      if (!allowed) return;
      const date = WjdDeliveryEstimate.arrival(new Date(), days);
      const label = new Intl.DateTimeFormat(document.documentElement.lang || 'en-US',{weekday:'long',month:'short',day:'numeric',timeZone:'UTC'}).format(date);
      this.querySelector('[data-arrival]').textContent = this.dataset.prefix.replace('[date]', label);
    }
  }
  customElements.define('wjd-delivery-estimate', WjdDeliveryEstimate);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wjd-edge-spring"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wjd-edge-spring')) {
  customElements.define('wjd-edge-spring', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.scope = this.parentElement;
      this.scroller = this.scope.querySelector(this.dataset.scroller);
      if (!this.scroller) return;
      this.axis = this.dataset.axis === 'x' ? 'x' : 'y';
      this.limit = this.axis === 'x' ? 26 : 44;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const preference = () => {
        this.reset();
        if (this.reduced.matches) this.scroller.removeAttribute('data-wjd-edge-axis');
        else this.scroller.setAttribute('data-wjd-edge-axis', this.axis);
      };
      this.reduced.addEventListener('change', preference, { signal });
      this.scroller.addEventListener('touchstart', event => this.start(event), { passive: true, signal });
      this.scroller.addEventListener('touchmove', event => this.move(event), { passive: false, signal });
      this.scroller.addEventListener('touchend', () => this.end(), { passive: true, signal });
      this.scroller.addEventListener('touchcancel', () => this.end(), { passive: true, signal });
      this.scroller.addEventListener('wheel', event => this.wheel(event), { passive: false, signal });
      this.scroller.addEventListener('scroll', () => this.nativeScroll(), { passive: true, signal });
      this.scroller.addEventListener('focusin', () => this.reset(), { capture: true, signal });
      this.scroller.addEventListener('click', event => {
        if (event.detail && performance.now() < (this.suppressUntil || 0)) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, { capture: true, signal });
      window.addEventListener('pagehide', () => this.reset(), { signal });
      window.addEventListener('resize', () => this.reset(), { passive: true, signal });
      preference();
    }
    metrics() {
      this.rtl = this.axis === 'x' && getComputedStyle(this.scroller).direction === 'rtl';
      this.max = Math.max(0, this.axis === 'x'
        ? this.scroller.scrollWidth - this.scroller.clientWidth
        : this.scroller.scrollHeight - this.scroller.clientHeight);
      this.lastPosition = this.position();
      this.lastTime = performance.now();
    }
    position() {
      const raw = this.axis === 'x' ? this.scroller.scrollLeft : this.scroller.scrollTop;
      return Math.max(0, Math.min(this.max || 0, this.rtl ? this.max + raw : raw));
    }
    outward(amount) {
      const position = this.position();
      return amount > 0 ? position <= 1 : position >= this.max - 1;
    }
    start(event) {
      this.reset();
      if (this.reduced.matches || event.touches.length !== 1) return;
      if (event.target.closest?.('input,textarea,select,[contenteditable="true"],video,iframe,model-viewer')) return;
      const touch = event.touches[0];
      if (this.axis === 'x' && (touch.clientX < 20 || touch.clientX > window.innerWidth - 20)) return;
      this.metrics();
      this.gesture = { x: touch.clientX, y: touch.clientY, last: this.axis === 'x' ? touch.clientX : touch.clientY, locked: false, ignored: false };
    }
    move(event) {
      const gesture = this.gesture;
      if (!gesture || this.reduced.matches) return;
      if (event.touches.length !== 1) { this.end(); return; }
      const touch = event.touches[0];
      const value = this.axis === 'x' ? touch.clientX : touch.clientY;
      if (!gesture.locked) {
        const primary = this.axis === 'x' ? touch.clientX - gesture.x : touch.clientY - gesture.y;
        const cross = this.axis === 'x' ? touch.clientY - gesture.y : touch.clientX - gesture.x;
        if (Math.max(Math.abs(primary), Math.abs(cross)) < 7) return;
        gesture.locked = true;
        gesture.ignored = Math.abs(cross) > Math.abs(primary);
      }
      const delta = value - gesture.last;
      gesture.last = value;
      if (gesture.ignored || !delta) return;
      if (this.raw && Math.sign(delta) !== Math.sign(this.raw)) {
        this.raw = Math.sign(this.raw + delta) === Math.sign(this.raw) ? this.raw + delta : 0;
      } else if (this.raw || this.outward(delta)) {
        this.raw = Math.max(-500, Math.min(500, (this.raw || 0) + delta));
      } else return;
      if (event.cancelable) event.preventDefault();
      gesture.dragged = true;
      this.paint(this.resist(this.raw));
    }
    resist(raw) {
      return Math.sign(raw) * this.limit * (1 - Math.exp(-Math.abs(raw) / 100));
    }
    acquireTarget() {
      if (this.target) return this.target;
      this.target = this.scope.querySelector(this.dataset.content);
      if (this.target) {
        this.savedTranslate = this.target.style.getPropertyValue('translate');
        this.savedPriority = this.target.style.getPropertyPriority('translate');
      }
      return this.target;
    }
    value(offset) { return this.axis === 'x' ? `${offset}px 0` : `0 ${offset}px`; }
    paint(offset) {
      this.offset = offset;
      if (!this.acquireTarget() || this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.target?.style.setProperty('translate', this.value(this.offset));
      });
    }
    end() {
      if (this.gesture?.dragged) this.suppressUntil = performance.now() + 160;
      const impact = this.pendingImpact;
      this.pendingImpact = null;
      this.gesture = null;
      if (!this.offset && impact) this.pulse(impact.edge, impact.speed);
      else this.settle();
    }
    settle() {
      clearTimeout(this.wheelTimer);
      this.wheelTimer = null;
      if (!this.target || !this.offset) { this.restore(); return; }
      this.animate([
        { translate: this.value(this.offset) },
        { translate: this.value(-this.offset * .13), offset: .58 },
        { translate: this.value(this.offset * .025), offset: .82 },
        { translate: this.value(0) }
      ], 420);
      this.raw = 0;
    }
    animate(frames, duration) {
      cancelAnimationFrame(this.frame);
      this.frame = null;
      if (this.reduced.matches || typeof this.target?.animate !== 'function') { this.restore(); return; }
      try {
        const motion = this.target.animate(frames, { duration, easing: 'cubic-bezier(.22,.61,.36,1)', fill: 'both' });
        this.motion = motion;
        motion.onfinish = () => {
          if (this.motion !== motion) return;
          this.motion = null;
          motion.cancel();
          this.restore();
        };
      } catch (error) { this.restore(); }
    }
    wheel(event) {
      if (this.reduced.matches || event.ctrlKey) return;
      const primary = this.axis === 'x' ? event.deltaX || (event.shiftKey ? event.deltaY : 0) : event.deltaY;
      const cross = this.axis === 'x' ? (event.shiftKey ? 0 : event.deltaY) : event.deltaX;
      if (!primary || Math.abs(cross) > Math.abs(primary)) return;
      if (!this.wheelTimer) {
        this.reset();
        this.metrics();
      }
      const unit = event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? (this.axis === 'x' ? this.scroller.clientWidth : this.scroller.clientHeight) : 1;
      const amount = -primary * unit;
      if (!this.raw && !this.outward(amount)) return;
      if (event.cancelable) event.preventDefault();
      if (this.raw && Math.sign(amount) !== Math.sign(this.raw)) {
        this.raw = Math.sign(this.raw + amount) === Math.sign(this.raw) ? this.raw + amount : 0;
      } else this.raw = Math.max(-500, Math.min(500, (this.raw || 0) + amount));
      this.paint(this.resist(this.raw));
      clearTimeout(this.wheelTimer);
      this.wheelTimer = setTimeout(() => this.settle(), 100);
    }
    nativeScroll() {
      if (this.reduced.matches || this.motion || this.offset) return;
      const previous = this.lastPosition;
      const previousTime = this.lastTime;
      this.metrics();
      const position = this.lastPosition;
      if (!Number.isFinite(previous) || !Number.isFinite(previousTime)) return;
      const speed = Math.abs(position - previous) / Math.max(16, this.lastTime - previousTime);
      const edge = position <= 1 && previous > 1 ? 1 : position >= this.max - 1 && previous < this.max - 1 ? -1 : 0;
      if (position > 1 && position < this.max - 1) this.pendingImpact = null;
      if (!edge || speed < .25) return;
      if (this.gesture) { this.pendingImpact = { edge, speed }; return; }
      this.pulse(edge, speed);
    }
    pulse(edge, speed) {
      if (!this.acquireTarget()) return;
      const amount = edge * Math.min(16, 5 + speed * 5);
      this.animate([
        { translate: this.value(0) },
        { translate: this.value(amount), offset: .28 },
        { translate: this.value(-amount * .12), offset: .65 },
        { translate: this.value(0) }
      ], 360);
    }
    restore() {
      cancelAnimationFrame(this.frame);
      this.frame = null;
      if (this.target) {
        if (this.savedTranslate) this.target.style.setProperty('translate', this.savedTranslate, this.savedPriority);
        else this.target.style.removeProperty('translate');
      }
      this.target = null;
      this.raw = this.offset = 0;
    }
    reset() {
      clearTimeout(this.wheelTimer);
      this.wheelTimer = null;
      const motion = this.motion;
      this.motion = null;
      motion?.cancel();
      this.gesture = null;
      this.pendingImpact = null;
      this.restore();
      this.lastPosition = this.lastTime = undefined;
    }
    disconnectedCallback() {
      this.reset();
      this.controller?.abort();
      this.controller = null;
      this.scroller?.removeAttribute('data-wjd-edge-axis');
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wjd-footer-motion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wjd-footer-motion')) {
  customElements.define('wjd-footer-motion', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.footer = this.closest('.wh-footer');
      if (!this.footer) return;
      this.events = new AbortController();
      this.preference = matchMedia('(prefers-reduced-motion: reduce)');
      this.hover = matchMedia('(hover: hover) and (pointer: fine)');
      this.seen = new WeakSet();
      this.waiting = new WeakSet();
      this.motions = new Map();
      this.targets = new Map();
      const signal = this.events.signal;
      this.footer.querySelector('[data-wjd-back-top]')?.addEventListener('click', event => {
        event.preventDefault();
        window.scrollTo({top:0,behavior:this.preference.matches ? 'instant' : 'smooth'});
        document.querySelector('.header a.link--logo,.header a.header__heading-link')?.focus({preventScroll:true});
      }, {signal});
      this.addTarget(this.footer.querySelector('.wh-footer-brand img'), 'brand');
      this.addTarget(this.footer.querySelector('.wh-chat .wh-icon'), 'chat');
      this.addTarget(this.footer.querySelector('.wh-footer-phone-icon'), 'phone');
      this.footer.querySelectorAll('.list-social__link').forEach(link => this.addTarget(link.querySelector('svg'), 'social'));
      this.targets.forEach((type, target) => {
        const link = target.closest('a');
        link?.addEventListener('pointerenter', () => { if (this.hover.matches) this.play(target, type); }, { signal });
        link?.addEventListener('focusin', () => this.play(target, type), { signal });
      });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting && entry.intersectionRatio >= .35) this.greet(entry.target);
          });
        }, { threshold: .35 });
        this.targets.forEach((type, target) => this.observer.observe(target));
      }
      this.preference.addEventListener('change', () => {
        if (this.preference.matches) this.cancel();
      }, { signal });
      window.addEventListener('pagehide', () => this.cancel(), { signal });
    }
    addTarget(target, type) { if (target) this.targets.set(target, type); }
    greet(target) {
      if (!this.isConnected || document.hidden || this.seen.has(target) || this.preference.matches) return;
      if (target.tagName === 'IMG' && !target.complete) {
        if (this.waiting.has(target)) return;
        this.waiting.add(target);
        target.addEventListener('load', () => { this.waiting.delete(target); this.greet(target); }, { once: true, signal: this.events.signal });
        return;
      }
      const rect = target.getBoundingClientRect();
      if (rect.bottom <= 0 || rect.top >= innerHeight || rect.right <= 0 || rect.left >= innerWidth) return;
      this.seen.add(target);
      this.observer?.unobserve(target);
      this.play(target, this.targets.get(target));
    }
    play(target, type) {
      if (!this.isConnected || document.hidden || !target.isConnected || this.preference.matches || typeof target.animate !== 'function') return;
      const frames = {
        brand: [{ transform: 'rotate(0) scale(1)' }, { transform: 'rotate(-5deg) scale(1.055)', offset: .28 }, { transform: 'rotate(2.5deg) scale(1.025)', offset: .62 }, { transform: 'rotate(0) scale(1)' }],
        chat: [{ transform: 'translate(0,0)' }, { transform: 'translate(3px,-3px)', offset: .36 }, { transform: 'translate(-1px,1px)', offset: .7 }, { transform: 'translate(0,0)' }],
        phone: [{ transform: 'rotate(0)' }, { transform: 'rotate(-17deg)', offset: .22 }, { transform: 'rotate(13deg)', offset: .43 }, { transform: 'rotate(-7deg)', offset: .64 }, { transform: 'rotate(0)' }],
        social: [{ transform: 'rotate(0) scale(1)' }, { transform: 'rotate(-10deg) scale(1.14)', offset: .34 }, { transform: 'rotate(5deg) scale(1.04)', offset: .67 }, { transform: 'rotate(0) scale(1)' }]
      }[type];
      if (!frames) return;
      this.motions.get(target)?.cancel();
      try {
        const motion = target.animate(frames, { duration: type === 'brand' ? 720 : type === 'phone' ? 640 : 520, easing: 'cubic-bezier(.22,.61,.36,1)' });
        this.motions.set(target, motion);
        const release = () => { if (this.motions.get(target) === motion) this.motions.delete(target); };
        motion.finished.then(release, release);
      } catch {}
    }
    cancel() { this.motions?.forEach(motion => motion.cancel()); this.motions?.clear(); }
    disconnectedCallback() {
      this.cancel(); this.observer?.disconnect(); this.events?.abort();
      this.targets?.clear(); this.events = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wjd-gallery-elastic"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wjd-gallery-elastic')) {
  customElements.define('wjd-gallery-elastic', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.list = this.parentElement.querySelector('.wg-slides');
      if (!this.list) return;
      this.events = new AbortController();
      const signal = this.events.signal;
      this.viewport = matchMedia('(max-width: 989px)');
      const refresh = () => {
        this.reset();
        this.list.toggleAttribute('data-wjd-gallery-bounded', this.enabled());
      };
      this.viewport.addEventListener('change', refresh, { signal });
      this.list.addEventListener('touchstart', event => this.start(event), { passive: true, signal });
      this.list.addEventListener('touchmove', event => this.move(event), { passive: false, signal });
      this.list.addEventListener('touchend', () => this.end(), { passive: true, signal });
      this.list.addEventListener('touchcancel', () => this.reset(), { passive: true, signal });
      this.list.addEventListener('click', event => {
        if (event.detail && performance.now() < (this.suppressUntil || 0)) {
          event.preventDefault(); event.stopImmediatePropagation();
        }
      }, { capture: true, signal });
      this.observer = new MutationObserver(refresh);
      this.observer.observe(this.list, { attributes: true, attributeFilter: ['class'], childList: true });
      window.addEventListener('pagehide', () => this.reset(), { signal });
      refresh();
    }
    enabled() {
      return this.viewport.matches && !this.list.classList.contains('has-zoom') && !this.list.closest('[data-wg-loop]');
    }
    geometry() {
      const max = Math.max(0, this.list.scrollWidth - this.list.clientWidth);
      const rtl = getComputedStyle(this.list).direction === 'rtl';
      const position = Math.max(0, Math.min(max, this.list.scrollLeft + (rtl ? max : 0)));
      return { max, position, edge: position <= 1 ? 1 : position >= max - 1 ? -1 : 0 };
    }
    start(event) {
      this.reset();
      if (!this.enabled() || event.touches.length !== 1) return;
      if (event.target.closest('button:not([data-wg-play]),input,textarea,select,video[controls],iframe,model-viewer,[contenteditable]:not([contenteditable="false"]),.is-zoomed')) return;
      const touch = event.touches[0];
      if (touch.clientX < 20 || touch.clientX > innerWidth - 20 || this.geometry().max <= 1) return;
      this.gesture = { x: touch.clientX, y: touch.clientY, last: touch.clientX };
    }
    move(event) {
      const gesture = this.gesture;
      if (!gesture) return;
      if (!this.enabled() || event.touches.length !== 1) { this.reset(); return; }
      const touch = event.touches[0];
      const dx = touch.clientX - gesture.x, dy = touch.clientY - gesture.y;
      if (!gesture.locked) {
        if (Math.max(Math.abs(dx), Math.abs(dy)) < 8) return;
        gesture.locked = true;
        gesture.ignored = Math.abs(dy) >= Math.abs(dx);
      }
      const delta = touch.clientX - gesture.last;
      gesture.last = touch.clientX;
      if (gesture.ignored || !delta || !event.cancelable) return;
      const state = this.geometry();
      if (state.edge && Math.sign(delta) === state.edge) {
        event.preventDefault();
        gesture.blocked = true;
      }
    }
    end() {
      if (this.gesture?.blocked) this.suppressUntil = performance.now() + 200;
      this.reset();
    }
    reset() { this.gesture = null; }
    disconnectedCallback() {
      this.reset(); this.events?.abort(); this.observer?.disconnect();
      this.list?.removeAttribute('data-wjd-gallery-bounded'); this.events = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wjd-home-product-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wjd-home-card-gallery')) {
  customElements.define('wjd-home-card-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const { signal } = this.events;
      const track = this.querySelector('.wh-card-views');
      const dots = this.querySelector('.wh-card-dots');
      const buttons = [...dots.querySelectorAll('button')];
      const views = [...track.children];
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const go = index => track.scrollTo({left: views[index].offsetLeft - views[0].offsetLeft, behavior: reduced.matches ? 'instant' : 'smooth'});
      buttons.forEach((button, index) => button.addEventListener('click', () => go(index), {signal}));
      const update = () => {
        const index = Math.max(0, Math.min(views.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
        buttons.forEach((button, n) => {
          if (n === index) button.setAttribute('aria-current', 'true');
          else button.removeAttribute('aria-current');
        });
      };
      track.addEventListener('scroll', () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; update(); });
      }, {passive: true, signal});
      track.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        const index = Math.round(track.scrollLeft / track.clientWidth);
        const next = Math.max(0, Math.min(views.length - 1, index + (event.key === 'ArrowRight' ? 1 : -1)));
        views[next].focus({preventScroll: true});
        go(next);
      }, {signal});
      dots.hidden = false;
    }
    disconnectedCallback() {
      this.events?.abort();
      this.events = null;
      cancelAnimationFrame(this.frame);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wjd-mobile-purchase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wjd-mobile-purchase')) {
    customElements.define('wjd-mobile-purchase', class extends HTMLElement {
      connectedCallback() {
        this.hostProduct = this.closest('product-info');
        this.mainButton = document.getElementById(`ProductSubmitButton-${this.dataset.section}`);
        this.form = document.getElementById(this.dataset.form);
        if (!this.hostProduct || !this.mainButton || !this.form) return;
        this.bar = this.querySelector('.wjd-mobile-purchase');
        this.action = this.querySelector('[data-purchase]');
        this.state = this.querySelector('[id^="WjdPurchaseState-"]');
        document.body.append(this.bar);
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.scrolledPast = false;
        this.measure = () => {
          if (this.bar.hidden) return;
          const height = Math.ceil(this.bar.getBoundingClientRect().height);
          if (!height || height === this.barHeight) return;
          this.barHeight = height;
          document.body.style.setProperty('--wjd-mobile-purchase-height', `${height}px`);
        };
        if ('ResizeObserver' in window) {
          this.sizeObserver = new ResizeObserver(this.measure);
          this.sizeObserver.observe(this.bar);
        }
        this.onClick = () => {
          if (this.action.disabled) return;
          const invalid = Array.from(this.hostProduct.querySelectorAll('input[required],select[required],textarea[required]')).find(input => !input.disabled && !input.checkValidity());
          if (invalid) {
            invalid.scrollIntoView({block:'center',behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
            invalid.focus({preventScroll:true});
            invalid.reportValidity();
            return;
          }
          this.mainButton.click();
        };
        this.action.addEventListener('click', this.onClick);
        this.sync = () => {
          const busy = this.mainButton.classList.contains('loading');
          this.action.disabled = this.mainButton.disabled || this.mainButton.getAttribute('aria-disabled') === 'true' || !this.form.querySelector('[name="id"]')?.value;
          this.action.textContent = busy ? this.querySelector('[data-adding]').textContent : this.mainButton.querySelector('span')?.textContent.trim() || this.mainButton.textContent.trim();
          this.action.setAttribute('aria-busy', String(busy));
          this.bar.querySelector('[data-price]').textContent = this.state.dataset.price;
          this.bar.querySelector('[data-options]').textContent = this.state.dataset.title;
          this.updateVisibility();
        };
        this.updateVisibility = () => {
          const show = this.mobile.matches && this.scrolledPast;
          if (show === this.shown) return;
          this.shown = show;
          this.bar.hidden = !show;
          if (show) this.measure();
          document.body.classList.toggle('wjd-has-mobile-purchase', show);
        };
        this.visibilityObserver = new IntersectionObserver(entries => {
          const entry = entries[0];
          this.scrolledPast = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          this.updateVisibility();
        });
        this.visibilityObserver.observe(this.mainButton);
        this.onScroll = () => {
          if (this.scrollFrame) return;
          this.scrollFrame = requestAnimationFrame(() => {
            this.scrollFrame = null;
            this.scrolledPast = this.mainButton.getBoundingClientRect().bottom < 0;
            this.updateVisibility();
          });
        };
        window.addEventListener('scroll',this.onScroll,{passive:true});
        this.buttonObserver = new MutationObserver(this.sync);
        this.buttonObserver.observe(this.mainButton,{attributes:true,childList:true,subtree:true,characterData:true});
        this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, ({data}) => {
          if (String(data.sectionId) !== this.dataset.section) return;
          const state = data.html.getElementById(this.state.id);
          if (state) {
            this.state.dataset.price = state.dataset.price;
            this.state.dataset.title = state.dataset.title;
            this.state.dataset.variant = state.dataset.variant;
          }
          const current = document.getElementById(`WjdPurchaseDetails-${this.dataset.section}`);
          const incoming = data.html.getElementById(`WjdPurchaseDetails-${this.dataset.section}`);
          if (current && incoming) current.innerHTML = incoming.innerHTML;
          this.sync();
        });
        this.mobile.addEventListener('change',this.updateVisibility);
        this.sync();
        this.onScroll();
      }
      disconnectedCallback() {
        this.visibilityObserver?.disconnect();
        this.buttonObserver?.disconnect();
        this.sizeObserver?.disconnect();
        this.unsubscribeVariant?.();
        this.action?.removeEventListener('click',this.onClick);
        this.mobile?.removeEventListener('change',this.updateVisibility);
        window.removeEventListener('scroll',this.onScroll);
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
        this.bar?.remove();
        document.body.classList.remove('wjd-has-mobile-purchase');
        document.body.style.removeProperty('--wjd-mobile-purchase-height');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wjd-nav-row"] && !Shopify.designMode) return;
  try {
    (() => {
  const root=document.documentElement;
  if(root.hasAttribute('data-wjd-nav-photo-fallback'))return;
  root.setAttribute('data-wjd-nav-photo-fallback','');
  const failed=image=>{
    if(image?.matches?.('.wjd-nav-visual>img'))image.remove();
  };
  document.addEventListener('error',event=>failed(event.target),true);
  const check=root=>root.querySelectorAll('.wjd-nav-visual>img').forEach(image=>{
    if(image.complete && image.currentSrc && !image.naturalWidth)failed(image);
  });
  check(document);
  document.addEventListener('shopify:section:load',event=>check(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wjd-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.documentElement;
  if (root.hasAttribute('data-wjd-input')) return;
  root.dataset.wjdInput = 'keyboard';
  const pointer = () => { root.dataset.wjdInput = 'pointer'; };
  const keys = new Set(['Tab', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Home', 'End', 'PageUp', 'PageDown', 'Enter', ' ', 'Escape']);
  document.addEventListener('keydown', event => {
    if (event.metaKey || event.ctrlKey || event.altKey || !keys.has(event.key)) return;
    root.dataset.wjdInput = 'keyboard';
  }, true);
  if ('PointerEvent' in window) {
    document.addEventListener('pointerdown', pointer, { capture: true, passive: true });
  } else {
    document.addEventListener('mousedown', pointer, { capture: true, passive: true });
    document.addEventListener('touchstart', pointer, { capture: true, passive: true });
  }
})();

if (!customElements.get('wjd-navigation')) {
  customElements.define('wjd-navigation', class extends HTMLElement {
    connectedCallback() {
      this.setupDesktop();
      if (this.ready) return;
      this.ready = true;
      this.dialog = this.querySelector('dialog');
      this.screens = [...this.querySelectorAll('[data-wn-screen]')];
      this.scrollArea = this.querySelector('.wn-content');
      this.heading = this.querySelector('.wn-title');
      this.back = this.querySelector('[data-wn-back]');
      this.stack = [];
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.setAttribute('data-ready', '');
      this.querySelector('[data-wn-mobile]').hidden = false;
      this.querySelectorAll('[data-wn-open]').forEach(button => button.addEventListener('click', event => {
        event.preventDefault();
        if (this.dialog.open || this.closing) return;
        this.querySelectorAll('.wjd-disclosure[open]').forEach(group => { group.open = false; });
        this.stack = [{id:button.dataset.wnOpen, scroll:0}];
        this.showScreen(button.dataset.wnOpen, false);
        this.dialog.showModal();
        document.documentElement.classList.add('wjd-navigation-lock');
        this.opener = button;
        button.setAttribute('aria-expanded', 'true');
        this.heading.focus({preventScroll:true});
        this.revealMenu();
      }));
      this.querySelector('[data-wn-close]').addEventListener('click', () => this.shut());
      this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.shut(); });
      this.dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('wjd-navigation-lock');
        this.closing = false;
        this.cancelChat();
        this.dialog.classList.remove('is-closing');
        this.opener?.setAttribute('aria-expanded', 'false');
      });
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.shut();
      });
      this.dialog.addEventListener('click', event => {
        const chat = event.target.closest('[data-wn-chat]');
        if (chat) { event.preventDefault(); this.openMenuChat(chat); return; }
        const button = event.target.closest('[data-go]');
        if (button && this.dialog.contains(button)) { event.preventDefault(); this.openLevel(button, event); }
      });
      this.back.addEventListener('click', () => {
        const previous = this.stack.pop();
        if (!this.stack.length) this.stack = [{id:'root',scroll:0}];
        this.showScreen(this.stack[this.stack.length-1].id, true, -1);
        previous?.opener?.focus({preventScroll:true});
      });
      this.dialog.querySelectorAll('a[href^="#"]').forEach(link => link.addEventListener('click', () => this.shut(true)));
      this.querySelector('[data-wn-search]').addEventListener('click', event => {
        const searchTrigger = document.querySelector('.search-m');
        this.shut(true);
        if (!searchTrigger) return;
        event.preventDefault();
        searchTrigger.click();
      });
    }

    scheduleWelcome() {
      if(this.welcomeStarted || this.reduced.matches || !matchMedia('(max-width:989px)').matches)return;
      this.welcomeStarted=true;
      this.welcomeEvents=new AbortController();
      const signal=this.welcomeEvents.signal;
      const reveal=()=>{
        if(signal.aborted || !this.isConnected || this.reduced.matches)return;
        if(document.hidden){document.addEventListener('visibilitychange',reveal,{once:true,signal});return;}
        const browse=this.querySelector('[data-wn-mobile]');
        const stars=document.querySelector('.wh-hero .wh-rating');
        const targets=[browse,stars].filter(Boolean);
        const show=target=>this.setAttribute(target===browse?'data-wjd-browse-welcome':'data-wjd-stars-welcome','');
        if(!('IntersectionObserver' in window)){targets.forEach(show);return;}
        this.welcomeObserver=new IntersectionObserver(entries=>{
          entries.forEach(entry=>{if(entry.isIntersecting){show(entry.target);this.welcomeObserver.unobserve(entry.target);}});
        },{threshold:.6});
        targets.forEach(target=>this.welcomeObserver.observe(target));
      };
      const paint=()=>{
        if(signal.aborted)return;
        this.welcomeFrame=requestAnimationFrame(()=>{this.welcomeFrame=requestAnimationFrame(reveal);});
      };
      const settle=()=>{
        this.welcomeTimer=setTimeout(()=>{
          if(signal.aborted)return;
          if('requestIdleCallback' in window)this.welcomeIdle=requestIdleCallback(paint,{timeout:1500});
          else paint();
        },650);
      };
      const loaded=()=>{
        const fonts=document.fonts?.ready||Promise.resolve();
        fonts.then(()=>{if(!signal.aborted)settle();},()=>{if(!signal.aborted)settle();});
      };
      if(document.readyState==='complete')loaded();
      else window.addEventListener('load',loaded,{once:true,signal});
    }

    setupDesktop() {
      this.desktopController?.abort();
      this.desktopController = new AbortController();
      const signal = this.desktopController.signal;
      const nav = this.querySelector('[data-wjd-desktop]');
      if (!nav) return;
      const groups = [...nav.querySelectorAll('.wjd-disclosure')];
      const desktop = matchMedia('(min-width: 990px)');
      const hover = matchMedia('(hover: hover) and (pointer: fine)');
      let openTimer, closeTimer, focusTimer;
      const clearHover = () => {
        clearTimeout(openTimer);
        clearTimeout(closeTimer);
      };
      signal.addEventListener('abort', () => {
        clearHover();
        clearTimeout(focusTimer);
      }, { once: true });
      const closeAll = except => {
        groups.forEach(group => {
          if (group !== except) group.open = false;
        });
      };
      const focusedGroup = () => groups.find(group => {
        if (document.documentElement.dataset.wjdInput === 'pointer' || !group.open) return false;
        const active = document.activeElement;
        const summary = group.querySelector('summary');
        return group.querySelector('.wjd-panel')?.contains(active) ||
          (active === summary && summary.matches(':focus-visible'));
      });
      const canHover = event => desktop.matches && hover.matches && event.pointerType === 'mouse';
      nav.querySelectorAll('.wjd-root').forEach(root => {
        const group = root.querySelector('.wjd-disclosure');
        root.addEventListener('pointerenter', event => {
          if (!canHover(event)) return;
          clearHover();
          if (group?.open) return;
          openTimer = setTimeout(() => {
            if (signal.aborted || !desktop.matches || !hover.matches) return;
            const focused = focusedGroup();
            if (focused && focused !== group) return;
            closeAll(group);
            if (group) group.open = true;
          }, 180);
        }, { signal });
        root.addEventListener('pointerleave', event => {
          if (!canHover(event)) return;
          clearHover();
          closeTimer = setTimeout(() => {
            if (!signal.aborted) closeAll(focusedGroup());
          }, 260);
        }, { signal });
      });
      groups.forEach(group => {
        const summary = group.querySelector('summary');
        summary.addEventListener('click', () => {
          clearHover();
          if (!group.open) closeAll(group);
        }, { signal });
        summary.addEventListener('keydown', event => {
          if (event.key !== 'ArrowDown') return;
          event.preventDefault();
          clearHover();
          closeAll(group);
          group.open = true;
          group.querySelector('a')?.focus();
        }, { signal });
      });
      document.addEventListener('click', event => {
        if (nav.contains(event.target)) return;
        clearHover();
        closeAll();
      }, { signal });
      nav.addEventListener('focusout', () => {
        clearTimeout(focusTimer);
        focusTimer = setTimeout(() => {
          if (signal.aborted) return;
          const active = document.activeElement;
          groups.forEach(group => {
            if (!group.contains(active)) group.open = false;
          });
        }, 0);
      }, { signal });
      nav.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        clearHover();
        const opened = groups.find(group => group.open);
        if (!opened) return;
        event.preventDefault();
        opened.open = false;
        opened.querySelector('summary').focus();
      }, { signal });
      desktop.addEventListener('change', () => {
        clearHover();
        closeAll();
        if (desktop.matches && this.dialog?.open) this.shut(true);
      }, { signal });
      hover.addEventListener('change', () => {
        clearHover();
        closeAll();
      }, { signal });
    }

    cancelMenuDetails() {
      clearTimeout(this.pendingLevel);
      this.pendingLevel = null;
      this.pressedButton?.removeAttribute('data-wn-pressed');
      this.pressedButton = null;
      this.dialog?.querySelector?.('wjd-edge-spring')?.reset?.();
      this.detailGeneration = (this.detailGeneration || 0) + 1;
      this.screenMotion?.cancel();
      (this.detailMotions || []).forEach(motion => motion.cancel());
      this.detailMotions = [];
    }

    revealMenu() {
      this.cancelMenuDetails();
      if (this.reduced.matches) return;
      this.motion = this.dialog.animate([
        { opacity: .65 },
        { opacity: 1 }
      ], { duration: 180, easing: 'ease-out' });
      this.greetMenuImages(this.screens.find(screen => !screen.hidden));
    }

    async greetMenuImages(screen, returning = false) {
      if (!screen || this.reduced.matches) return;
      const generation = this.detailGeneration;
      await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
      if (generation !== this.detailGeneration || !this.dialog.open || screen.hidden) return;
      const bounds = this.scrollArea.getBoundingClientRect();
      const pictures = [...screen.querySelectorAll('.wjd-row-image')].filter(picture => {
        const rect = picture.getBoundingClientRect();
        return rect.bottom > bounds.top && rect.top < bounds.bottom;
      }).slice(0,12);
      await Promise.allSettled(pictures.map(picture => {
        if (picture.tagName !== 'IMG') return Promise.resolve();
        picture.loading = 'eager'; picture.decoding = 'async';
        if (typeof picture.decode === 'function') return picture.decode();
        if (picture.complete) return Promise.resolve();
        return new Promise(resolve => {
          picture.addEventListener('load',resolve,{once:true,signal:this.desktopController.signal});
          picture.addEventListener('error',resolve,{once:true,signal:this.desktopController.signal});
        });
      }));
      if (generation !== this.detailGeneration || !this.dialog.open || this.closing || screen.hidden || this.reduced.matches) return;
      pictures.forEach((picture,index) => {
        if (!picture.isConnected || typeof picture.animate !== 'function') return;
        if (picture.tagName === 'IMG' && !picture.naturalWidth) return;
        try {
          this.detailMotions.push(picture.animate([
            {transform:'translateY(0) rotate(0) scale(1)'},
            {transform:'translateY(-6px) rotate(-10deg) scale(1.14)',offset:.28},
            {transform:'translateY(0) rotate(6deg) scale(1.05)',offset:.56},
            {transform:'translateY(-2px) rotate(-2deg) scale(1.02)',offset:.78},
            {transform:'translateY(0) rotate(0) scale(1)'}
          ],{duration:760,delay:returning ? Math.min(index*16,64) : 70+Math.min(index*40,160),easing:'cubic-bezier(.22,.61,.36,1)',fill:'backwards'}));
        } catch {}
      });
    }

    openLevel(button, event) {
      this.cancelMenuDetails();
      const open = () => {
        this.pendingLevel = null;
        if (!this.dialog.open || this.closing || !button.isConnected) return;
        this.stack[this.stack.length - 1].scroll = this.scrollArea.scrollTop;
        this.stack.push({ id: button.dataset.go, scroll: 0, opener: button });
        this.showScreen(button.dataset.go);
      };
      const picture = button.classList.contains('wjd-row--secondary') ? null : button.querySelector('.wjd-row-image');
      if (!picture || this.reduced.matches || event.detail === 0 || typeof picture.animate !== 'function') { open(); return; }
      this.pressedButton = button;
      button.setAttribute('data-wn-pressed', '');
      try {
        this.detailMotions.push(picture.animate([
          { transform: 'translateY(0) rotate(-6deg) scale(.88)' },
          { transform: 'translateY(-5px) rotate(5deg) scale(1.13)', offset: .55 },
          { transform: 'translateY(0) rotate(0) scale(1)' }
        ], { duration: 220, easing: 'cubic-bezier(.4,0,1,1)' }));
      } catch (error) { open(); return; }
      this.pendingLevel = setTimeout(open, 140);
    }

    showScreen(id, animate = true, direction = 1) {
      this.cancelChat();
      let incoming = this.screens.find(screen => screen.dataset.wnScreen === id);
      if (!incoming) {
        const source = [...this.scrollArea.querySelectorAll('template[data-wn-template]')].find(template => template.dataset.wnTemplate === id);
        if (!source) return;
        incoming = source.content.firstElementChild.cloneNode(true);
        this.scrollArea.append(incoming);
        source.remove();
        this.screens.push(incoming);
      }
      this.uniqueMenuImages(incoming);
      this.cancelMenuDetails();
      this.screens.forEach(screen => { screen.hidden = screen !== incoming; });
      this.heading.textContent = incoming.dataset.title;
      this.back.hidden = this.stack.length <= 1;
      this.dialog.toggleAttribute('data-wn-contact', incoming.dataset.wnScreen === 'contact');
      this.scrollArea.scrollTop = this.stack[this.stack.length - 1]?.scroll || 0;
      if (!animate) return;
      this.heading.focus({ preventScroll: true });
      if (this.reduced.matches) return;
      const distance = direction < 0 ? -1 : 1;
      this.screenMotion = incoming.animate([
        { opacity: .35, transform: `translateX(${distance * 24}%)` },
        { opacity: 1, transform: 'translateX(0)' }
      ], { duration: 300, easing: 'cubic-bezier(.22,.61,.36,1)' });
      this.detailMotions.push(this.heading.animate([
        { opacity: .65, transform: `translateX(${distance * 10}px)` },
        { opacity: 1, transform: 'translateX(0)' }
      ], { duration: 200, easing: 'cubic-bezier(.16,1,.3,1)' }));
      if (incoming.dataset.wnScreen === 'root') {
        this.greetMenuImages(incoming, true);
      }
    }

    uniqueMenuImages(screen) {
      const used = new Set();
      const identity = source => { try { return new URL(source, location.origin).pathname; } catch { return source; } };
      screen.querySelectorAll('img.wjd-row-image').forEach(image => {
        const source = image.getAttribute('src');
        if (!source || used.has(identity(source))) { image.remove(); return; }
        used.add(identity(source));
      });
    }


    cancelChat() {
      clearTimeout(this.chatTimer);
      this.chatGeneration = (this.chatGeneration || 0) + 1;
      this.querySelector('[data-wn-chat][aria-busy]')?.removeAttribute('aria-busy');
      const status = this.querySelector('[data-wn-chat-status]');
      if (status) status.hidden = true;
    }

    chatLauncher() {
      const chat = document.querySelector('shopify-chat');
      const runtime = chat?.shadowRoot?.querySelector('shopify-agent-runtime');
      return runtime?.shadowRoot?.querySelector('button[part~="activator"]')
        || chat?.shadowRoot?.querySelector('button[part~="activator"]')
        || document.querySelector('inbox-online-store-chat')?.shadowRoot?.querySelector('button');
    }

    openMenuChat(button) {
      if (button.getAttribute('aria-busy') === 'true') return;
      this.cancelChat();
      const chatSource = 'https://cdn.shopify.com/storefront/web-components/chat.js';
      const deferred = [...document.querySelectorAll('script[data-src]')].find(script => script.getAttribute('data-src') === chatSource);
      if (deferred && !document.querySelector('script[src="' + chatSource + '"]')) {
        const script = deferred.cloneNode(false);
        script.type = 'module';
        script.src = chatSource;
        script.removeAttribute('data-src');
        script.async = true;
        deferred.removeAttribute('data-src');
        deferred.replaceWith(script);
      }
      const generation = this.chatGeneration;
      const screen = button.closest('[data-wn-screen]');
      const status = screen.querySelector('[data-wn-chat-status]');
      button.removeAttribute('data-chat-unavailable');
      button.setAttribute('aria-busy', 'true');
      status.textContent = screen.dataset.chatLoading;
      status.hidden = false;
      const started = Date.now();
      const attempt = () => {
        if (generation !== this.chatGeneration || !this.dialog.open || screen.hidden) return;
        const launcher = this.chatLauncher();
        if (launcher) {
          this.shut(true);
          if (typeof window.openChat === 'function') window.openChat();
          else if (launcher.getAttribute('aria-expanded') !== 'true') launcher.click();
          return;
        }
        if (Date.now() - started >= 8000) {
          button.removeAttribute('aria-busy');
          button.setAttribute('data-chat-unavailable', '');
          status.textContent = screen.dataset.chatError;
          return;
        }
        this.chatTimer = setTimeout(attempt, 200);
      };
      attempt();
    }

    shut(immediate = false) {
      if (!this.dialog.open || this.closing) return;
      this.closing = true;
      this.cancelChat();
      this.motion?.cancel();
      this.cancelMenuDetails();
      this.dialog.classList.add('is-closing');
      if (immediate || this.reduced.matches) { this.dialog.close(); return; }
      this.motion = this.dialog.animate([
        {opacity:1},
        {opacity:0}
      ], {duration:150,easing:'cubic-bezier(.4,0,1,1)',fill:'forwards'});
      this.motion.onfinish = () => { this.dialog.close(); this.motion.cancel(); };
    }
    disconnectedCallback() {
      this.welcomeEvents?.abort();
      clearTimeout(this.welcomeTimer);
      if(this.welcomeIdle && 'cancelIdleCallback' in window)cancelIdleCallback(this.welcomeIdle);
      cancelAnimationFrame(this.welcomeFrame);
      this.welcomeObserver?.disconnect();
      this.cancelChat();
      this.desktopController?.abort();
      this.motion?.cancel();
      this.cancelMenuDetails();
      if (this.dialog?.open) this.dialog.close();
      document.documentElement.classList.remove('wjd-navigation-lock');
    }
  });
}

if (!customElements.get('wjd-brand-moment')) {
  customElements.define('wjd-brand-moment', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.logos=[...document.querySelectorAll('.header .header__heading-logo-wrapper')].filter(logo=>logo.querySelector('.header__heading-logo'));
      if (!this.logos.length) return;
      this.events=new AbortController();
      this.mobile=matchMedia('(max-width:989px)');
      this.reduced=matchMedia('(prefers-reduced-motion:reduce)');
      this.faces=this.logos.map(logo=>{
        const face=document.createElement('span');face.className='wjd-brand-nyc';face.setAttribute('aria-hidden','true');
        face.innerHTML='<svg viewBox="0 0 54 29" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M4 21 10 3 16 20 22 3M26 4l4 8 8-9m-8 9-3 11M51 5c-8-8-17 6-13 14 2 4 8 2 12-2M4 27c14-4 29-3 45-2"/></svg>';
        logo.classList.add('wjd-brand-flip');logo.append(face);return face;
      });
      const signal=this.events.signal;
      const schedule=()=>{this.stop();this.schedule();};
      document.addEventListener('visibilitychange',schedule,{signal});
      this.mobile.addEventListener('change',schedule,{signal});this.reduced.addEventListener('change',schedule,{signal});
      window.addEventListener('pagehide',()=>this.stop(),{signal});
      window.addEventListener('pageshow',schedule,{signal});
      if ('IntersectionObserver' in window) {
        this.observer=new IntersectionObserver(()=>this.schedule());
        this.logos.forEach(logo=>this.observer.observe(logo));
      }
      this.addEventListener('wjd-brand-play', () => this.play(true), { signal });
      const ready = () => Promise.resolve(document.fonts?.ready).then(() => {
        if (signal.aborted) return;
        this.ready = true;
        this.nextAt = Date.now() + 5000;
        this.schedule();
      });
      if (document.readyState === 'complete') ready();
      else window.addEventListener('load', ready, { once: true, signal });
    }
    history() {
      try {return JSON.parse(sessionStorage.getItem('wjd-brand-moment-v2') || 'null') || {count:0,last:0};}
      catch {return this.memory || {count:0,last:0};}
    }
    visibleLogo() {
      return this.logos.find(logo=>{
        if (!logo.isConnected) return false;
        const rect=logo.getBoundingClientRect();
        return rect.width>0 && rect.height>0 && rect.bottom>0 && rect.top<innerHeight && getComputedStyle(logo).visibility!=='hidden';
      });
    }
    schedule() {
      clearTimeout(this.timer);
      const history=this.history();
      if (!this.ready || this.motion || !this.mobile.matches || this.reduced.matches || document.hidden || !this.visibleLogo()) return;
      this.timer=setTimeout(()=>this.play(),Math.max(1000,(this.nextAt || Date.now()+5000)-Date.now()));
    }
       play(manual = false) {
      if (!this.isConnected || document.hidden || !this.mobile.matches || this.reduced.matches || this.motion) return;
      clearTimeout(this.timer);
      this.logo=this.visibleLogo();
      if (!this.logo) return;

      const image=this.logo.querySelector('.header__heading-logo');
      const face=this.logo.querySelector('.wjd-brand-nyc');
      if (!image || !face) return;

      const modalOpen=[...document.querySelectorAll('dialog[open],[aria-modal="true"]')].some(modal=>modal.getClientRects().length && getComputedStyle(modal).visibility!=='hidden' && getComputedStyle(modal).opacity!=='0');

      if (modalOpen || (!manual && this.logo.closest('a')?.contains(document.activeElement))) {
        this.timer=setTimeout(()=>this.play(),10000);
        return;
      }

      const history=this.history();
      this.nextAt=Date.now()+120000;
      this.memory={count:history.count+1,last:Date.now()};

      try {
        sessionStorage.setItem('wjd-brand-moment-v2',JSON.stringify(this.memory));
      } catch {}

      const options={duration:1900,easing:'linear'};

      const motion=image.animate([
        {
          transform:'rotateY(0deg)',
          opacity:1,
          offset:0,
          easing:'cubic-bezier(.4,0,.2,1)'
        },
        {
          transform:'rotateY(90deg)',
          opacity:0,
          offset:.16
        },
        {
          transform:'rotateY(-90deg)',
          opacity:0,
          offset:.82,
          easing:'cubic-bezier(.4,0,.2,1)'
        },
        {
          transform:'rotateY(0deg)',
          opacity:1,
          offset:1
        }
      ],options);

      this.faceMotion=face.animate([
        {
          transform:'rotateY(-90deg)',
          opacity:0,
          offset:0
        },
        {
          transform:'rotateY(-90deg)',
          opacity:0,
          offset:.16,
          easing:'cubic-bezier(.4,0,.2,1)'
        },
        {
          transform:'rotateY(0deg)',
          opacity:1,
          offset:.32
        },
        {
          transform:'rotateY(0deg)',
          opacity:1,
          offset:.64,
          easing:'cubic-bezier(.4,0,.2,1)'
        },
        {
          transform:'rotateY(90deg)',
          opacity:0,
          offset:.82
        },
        {
          transform:'rotateY(90deg)',
          opacity:0,
          offset:1
        }
      ],options);

      this.motion=motion;

      motion.finished.then(()=>{
        if (this.motion!==motion) return;
        this.faceMotion?.cancel();
        this.faceMotion=null;
        this.motion=null;
        this.schedule();
      },()=>{});
    }

    stop() {
      clearTimeout(this.timer);
      this.motion?.cancel();
      this.faceMotion?.cancel();
      this.motion=null;
      this.faceMotion=null;
    }
    disconnectedCallback() {this.stop();this.observer?.disconnect();this.events?.abort();this.events=null;this.faces?.forEach(face=>face.remove());this.logos?.forEach(logo=>logo.classList.remove('wjd-brand-flip'));}
  });
}

if (!customElements.get('wjd-collection-chrome')) {
  customElements.define('wjd-collection-chrome', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.header = this.closest('.section-header') || document.querySelector('.section-header');
      if (!this.header) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.measure();
        });
      };
      document.documentElement.classList.add('wjd-collection-chrome');
      this.resize = new ResizeObserver(schedule);
      this.resize.observe(this.header);
      this.mutations = new MutationObserver(schedule);
      this.mutations.observe(this.header, { attributes: true, attributeFilter: ['class', 'style'] });
      window.addEventListener('resize', schedule, { passive: true, signal });
      window.addEventListener('pageshow', schedule, { signal });
      this.measure();
    }
    measure() {
      const style = getComputedStyle(this.header);
      const hidden = this.header.classList.contains('shopify-section-header-hidden') && !this.header.classList.contains('menu-open');
      const sticky = style.position === 'sticky' || style.position === 'fixed';
      const height = sticky && !hidden ? Math.ceil(this.header.getBoundingClientRect().height) : 0;
      if (height === this.height) return;
      this.height = height;
      document.documentElement.style.setProperty('--wjd-collection-header-height', `${height}px`);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.resize?.disconnect();
      this.mutations?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = null;
      this.height = null;
      if (!document.querySelector('wjd-collection-chrome')) {
        document.documentElement.classList.remove('wjd-collection-chrome');
        document.documentElement.style.removeProperty('--wjd-collection-header-height');
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wjd-new-labels"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wjd-new-labels')) {
  customElements.define('wjd-new-labels', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();

      const syncFireVisibility = () => {
        document.documentElement.toggleAttribute(
          'data-wjd-fire-paused',
          document.hidden
        );
      };

      document.addEventListener(
        'visibilitychange',
        syncFireVisibility,
        { signal: this.events.signal }
      );

      syncFireVisibility();
      this.started = performance.now();
      this.serverNow = Number(this.dataset.now) * 1000;
      this.pending = new Set();
      this.owned = new Map();
      this.savedButtons = new Map();
      this.titleRows = new Map();
      this.couponCards = new Map();
      this.couponCache = new Map();
      this.publicationDates = new WeakMap();
      this.couponTasks = [];
      this.couponActive = 0;
      if ('IntersectionObserver' in window) this.couponObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          const card = this.couponCards.get(entry.target);
          if (card) this.queueCoupon(card);
          this.couponObserver.unobserve(entry.target);
        });
      }, {rootMargin:'200px 0px'});
      this.wishlistIntents = [];
      this.wishlistItems = undefined;
      this.wishlistMode = 'PRODUCT';
      this.wishlistVersion = 0;
      this.wishlistReading = null;
      this.wishlistWorking = false;
      this.saveMotions = new Map();
      this.hiddenSaveDuplicates = new Set();
      this.clearedPhotos = new Set();
      this.imageFallbacks = new Set();
      this.fireBadges = new WeakSet();
      this.wishlistSelector = '.swym-button,.swym-collection-btn,.swym-add-to-wishlist,.swym-add-to-wishlist-view-product,.swym-heart,.st-wishlist-button,wishlist-button-collection,wishlist-button-product,[data-swaction="addToWishlist"],[aria-label*="wishlist" i],[title*="wishlist" i]';
      this.selector = '.wh-product[data-product-id],.boost-sd__product-item[data-product],.card__inner[data-wjd-new-published],product-info.wjd-studio-product[data-product-id]';
      document.addEventListener('click', event => {
        const button = event.target.closest?.('button.wjd-inline-save');
        if (!button || ![...this.savedButtons.values()].some(entry => entry.button === button)) return;
        event.preventDefault(); event.stopImmediatePropagation();
        this.toggleWishlist(button);
      }, {capture:true,signal:this.events.signal});
      ['wk:wishlist:add:success','wk:wishlist:remove:success','wk:state:refetch','wk:customer:login','wk:customer:logout'].forEach(name => document.addEventListener(name, () => this.scheduleWishlistRefresh(), {signal:this.events.signal}));
      document.addEventListener('change', event => {
        const card = this.cardFor(event.target);
        if (card) { this.queue(card); this.syncWishlistButtons(); }
      }, {signal:this.events.signal});
      window.addEventListener('focus', () => this.scheduleWishlistRefresh(), {signal:this.events.signal});
      this.collect(document);
      this.wishlistApp().then(() => this.scheduleWishlistRefresh()).catch(() => {});
      this.observer = new MutationObserver(records => {
        records.forEach(record => {
          if (record.type === 'attributes' && record.attributeName === 'class') {
            const external = value => (value || '').split(/\s+/).filter(name => name && !name.startsWith('wjd-')).sort().join(' ');
            if (external(record.oldValue) === external(record.target.getAttribute('class'))) return;
            if (!record.target.matches(this.wishlistSelector) && !record.target.querySelector(this.wishlistSelector)) return;
          }
          if (record.type === 'attributes') {
            const card = this.cardFor(record.target);
            if (card) this.queue(card);
          } else {
            const added = [...record.addedNodes].filter(node => node.nodeType === 1 && !node.classList.contains('wjd-new-label'));
            if (!added.length && !record.removedNodes.length) return;
            const card = this.cardFor(record.target);
            if (card) this.queue(card);
            added.forEach(node => this.collect(node));
          }
        });
      });
      this.observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeOldValue: true, attributeFilter: ['data-product','data-wjd-new-published','data-product-id','data-swaction','aria-label','title','class'] });
      window.addEventListener('resize', () => {
        for (const card of this.owned.keys()) this.queue(card);
        for (const entry of this.savedButtons.values()) this.queue(entry.card);
      }, { passive: true, signal: this.events.signal });
      window.addEventListener('pageshow', () => this.collect(document), { signal: this.events.signal });
    }
    now() { return this.serverNow + performance.now() - this.started; }
    published(value) {
      if (value == null || value === '') return NaN;
      const text = String(value).trim();
      return /^\d{10,13}$/.test(text) ? Number(text) * (text.length < 13 ? 1000 : 1) : Date.parse(text);
    }
    isNew(published) {
      const age = this.now() - published;
      return Number.isFinite(published) && age >= 0 && age < 30 * 86400000;
    }
    collect(root) {
      const card = this.cardFor(root);
      if (card) this.queue(card);
      root.querySelectorAll?.(this.selector).forEach(node => this.queue(node));
    }
    queue(node) {
      this.pending.add(node);
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        const nodes = [...this.pending]; this.pending.clear();
        nodes.forEach(card => this.update(card));
        for (const [card, entry] of this.owned) {
          if (!card.isConnected || !entry.host.isConnected) this.owned.delete(card);
        }
        for (const [scope, entry] of this.savedButtons) {
          if (!scope.isConnected) this.savedButtons.delete(scope);
        }
        for (const row of this.titleRows.keys()) { if (!row.isConnected) this.titleRows.delete(row); }
        for (const [card, entry] of this.couponCards) {
          if (!card.isConnected) { this.couponObserver?.unobserve(card); entry.mount.remove(); this.couponCards.delete(card); }
        }
        for (const button of this.hiddenSaveDuplicates) {
          if (!button.isConnected) this.hiddenSaveDuplicates.delete(button);
        }
        for (const photo of this.clearedPhotos) { if (!photo.isConnected) this.clearedPhotos.delete(photo); }
        for (const host of this.imageFallbacks) { if (!host.isConnected) this.imageFallbacks.delete(host); }
        this.scheduleExpiry();
      });
    }
    update(card) {
      if (!card.isConnected) return;
      let published, host;
      if (card.matches('.boost-sd__product-item')) {
        let product;
        try { product = JSON.parse(card.getAttribute('data-product')); } catch { product = null; }
        published = this.published(product?.published_at ?? product?.publishedAt);
        if (!Number.isFinite(published)) {
          const cached = this.publicationDates.get(card);
          if (cached?.source === card.getAttribute('data-product')) published = cached.published;
        }
        host = card.querySelector('.boost-sd__product-image-wrapper') || card.querySelector('.boost-sd__product-image');
      } else if (card.matches('.wh-product')) {
        published = this.published(card.dataset.wjdNewPublished);
        host = card.querySelector('.wh-product-image');
      } else if (card.matches('.card__inner')) {
        published = this.published(card.dataset.wjdNewPublished);
        host = card;
      } else {
        if (card.dataset.productId !== this.dataset.productId) {
          const entry = this.owned.get(card);
          if (entry) { entry.label.remove(); entry.host.classList.remove('wjd-new-label-host'); this.owned.delete(card); }
          return;
        }
        published = this.published(this.dataset.published);
        host = card.querySelector('wjd-studio-gallery .wg-viewer');
      }
      this.prepareFireBadges(card);
      this.arrangeSave(card, host);
      if (card.matches('.boost-sd__product-item')) this.arrangeCoupon(card);
      const previous = this.owned.get(card);
      if (previous && previous.host !== host) {
        previous.label.remove(); previous.host.classList.remove('wjd-new-label-host');
        this.owned.delete(card);
      }
      if (!host || !this.isNew(published)) {
        const entry = this.owned.get(card);
        if (entry) { entry.label.remove(); entry.host.classList.remove('wjd-new-label-host'); this.owned.delete(card); }
        return;
      }
      const entry = this.owned.get(card);
      if (entry?.label.parentElement === host) { entry.published = published; this.matchSaleLabel(card, entry.label); return; }
      const label = document.createElement('span');
      label.className = 'wjd-new-label'; label.textContent = this.dataset.label;
      this.matchSaleLabel(card, label);
      host.classList.add('wjd-new-label-host');
      host.append(label);
      this.owned.set(card, { host, label, published });
    }

    prepareFireBadges(card) {
      if (!('IntersectionObserver' in window) ||
          matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      const scope = card.closest('.product-card-wrapper') || card;
      scope.querySelectorAll(
        '.boost-sd__product-label,.card__badge .badge,.wjd-price-badge'
      ).forEach(badge => {
        if (this.fireBadges.has(badge) ||
            !badge.textContent.includes('🔥')) return;

        this.fireBadges.add(badge);
        const walker = document.createTreeWalker(badge, NodeFilter.SHOW_TEXT);
        const nodes = [];

        while (walker.nextNode()) {
          if (walker.currentNode.data.includes('🔥') &&
              !walker.currentNode.parentElement.closest('.wjd-deal-flame')) {
            nodes.push(walker.currentNode);
          }
        }

        nodes.forEach(node => {
          const parts = node.data.split(/(🔥\uFE0F?)/u);
          const fragment = document.createDocumentFragment();

          parts.forEach(part => {
            if (!part.startsWith('🔥')) {
              fragment.append(document.createTextNode(part));
              return;
            }

            const flame = document.createElement('span');
            flame.className = 'wjd-deal-flame';
            flame.textContent = part;
            flame.setAttribute('aria-hidden', 'true');
            fragment.append(flame);

            if (!this.fireObserver) {
              this.fireObserver = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                  if (!entry.target.isConnected) {
                    this.fireObserver.unobserve(entry.target);
                    return;
                  }
                  entry.target.toggleAttribute(
                    'data-wjd-fire-seen', entry.isIntersecting
                  );
                });
              });
            }

            this.fireObserver.observe(flame);
          });

          node.replaceWith(fragment);
        });
      });
    }

    matchSaleLabel(card, label) {
      if (label.hasAttribute('style')) {
        label.removeAttribute('style');
      }
    }
    cardFor(node) {
      const element = node?.nodeType === 1 ? node : node?.parentElement;
      if (!element) return null;
      return element.closest(this.selector) || element.closest('.product-card-wrapper')?.querySelector('.card__inner[data-wjd-new-published]') || null;
    }
    wishlistControls(root) {
      const nodes = [...root.querySelectorAll(this.wishlistSelector)];
      return [...new Set(nodes.map(node => {
        if (node.matches('button,a,[role="button"],[data-swaction],.swym-collection-btn,.swym-add-to-wishlist,.swym-add-to-wishlist-view-product,.st-wishlist-button')) return node;
        return node.closest('button,a,[role="button"],[data-swaction],.swym-button,.swym-collection-btn,.swym-add-to-wishlist,.swym-add-to-wishlist-view-product,.st-wishlist-button');
      }).filter(Boolean))];
    }
    reserveImageSave(labelHost, image) {
      if (!labelHost || !image) return;
      const nodes = [...image.querySelectorAll(this.wishlistSelector)].filter(node => !node.classList.contains('wjd-inline-save') && !node.closest('.wjd-save-photo-cleared'));
      const hasImageSave = nodes.some(node => node.getClientRects().length);
      if (hasImageSave) {
        labelHost.style.setProperty('--wjd-new-label-end', '56px');
        this.imageFallbacks.add(labelHost);
      } else if (this.imageFallbacks.has(labelHost)) {
        labelHost.style.removeProperty('--wjd-new-label-end');
        this.imageFallbacks.delete(labelHost);
      }
    }
    saveTitleRow(scope,native) {
      let title = native ? [...scope.querySelectorAll('.card__heading')].filter(node => !node.closest('.card__inner')).pop() : scope.querySelector('.boost-sd__product-title,.wh-product-title');
      if (!title) return null;
      const label = title;
      title = title.closest('a') || title;
      if (title.querySelector('.boost-sd__product-image,.card__media')) return null;
      let row = title.parentElement;
      if (!row.classList.contains('wjd-card-title-row')) {
        row = document.createElement('div'); row.className = 'wjd-card-title-row';
        title.before(row); row.append(title);
      }
      title.setAttribute('data-wjd-save-title','');
      label.setAttribute('data-wjd-full-title','');
      const style = getComputedStyle(label);
      const line = parseFloat(style.lineHeight) || parseFloat(style.fontSize) * 1.4 || 22;
      row.style.setProperty('--wjd-title-line',line + 'px');
      this.titleRows.set(row,title);
      return row;
    }
    arrangeSave(card, labelHost) {
      const native = card.matches('.card__inner');
      const product = card.matches('product-info');
      const scope = native ? card.closest('.product-card-wrapper') : card;
      if (!scope) return;
      const photo = product ? scope.querySelector('.product__media-wrapper') || scope.querySelector('.wg-viewer')
        : native ? card : scope.querySelector('.wh-product-image,.boost-sd__product-image-wrapper') || scope.querySelector('.boost-sd__product-image')?.parentElement;
      if (!photo) return;
      const titleRow = product ? null : this.saveTitleRow(scope,native);
      const host = titleRow || scope.querySelector(product || native ? '.price__container' : '.boost-sd__product-price-wrapper,.boost-sd__product-price');
      if (!host) { this.reserveImageSave(labelHost, photo); return; }
      if (product) {
        const priceRoot = host.closest('.price');
        const badge = priceRoot?.querySelector(':scope > wjd-flash-deal,:scope > .wjd-price-badge');
        if (badge) { badge.classList.add('wjd-product-deal'); host.append(badge); }
      }
      let entry = this.savedButtons.get(scope);
      if (entry && !entry.button.isConnected) { entry.feedback.remove(); this.savedButtons.delete(scope); entry = null; }
      if (!entry) {
        const button = scope.querySelector('button.wjd-inline-save') || document.createElement('button');
        button.type = 'button'; button.className = 'wjd-inline-save';
        ['width','height','min-width','min-height'].forEach(name => button.style.setProperty(name,'44px','important'));
        button.style.setProperty('color','#222','important');
        button.style.setProperty('-webkit-text-fill-color','#222','important');
        button.setAttribute('aria-label', this.dataset.saveLabel);
        button.innerHTML = '<svg class="bi bi-heart" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M20.6 4.6a5.4 5.4 0 0 0-7.6 0L12 5.7l-1.1-1.1a5.4 5.4 0 0 0-7.6 7.6L12 21l8.6-8.8a5.4 5.4 0 0 0 0-7.6Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/></svg><svg class="bi bi-heart-fill" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M20.6 4.6a5.4 5.4 0 0 0-7.6 0L12 5.7l-1.1-1.1a5.4 5.4 0 0 0-7.6 7.6L12 21l8.6-8.8a5.4 5.4 0 0 0 0-7.6Z"/></svg>';
        button.querySelectorAll('svg').forEach(svg => {
          svg.style.setProperty('width','18px','important'); svg.style.setProperty('height','18px','important'); svg.style.setProperty('color','#222','important');
        });
        const feedback = scope.querySelector('.wjd-save-feedback') || document.createElement('span');
        feedback.className = 'wjd-save-feedback'; feedback.setAttribute('role','status'); feedback.hidden = true;
        entry = {card,scope,host,button,feedback};
        this.savedButtons.set(scope,entry);
        this.scheduleWishlistRefresh();
      }
      if (entry.host !== host) entry.host.classList.remove('wjd-save-host');
      entry.host = host;
      if (!titleRow) host.classList.add('wjd-save-host');
      if (entry.button.parentElement !== host) host.append(entry.button);
      if (entry.feedback.parentElement !== host.parentElement) host.after(entry.feedback);
      scope.classList.add('wjd-save-photo-cleared');
      this.clearedPhotos.add(scope);
      this.wishlistControls(scope).forEach(duplicate => {
        if (duplicate === entry.button || duplicate.classList.contains('wjd-save-image-duplicate') || duplicate.closest('quick-add-modal,dialog,.quick-add-modal')) return;
        duplicate.classList.add('wjd-save-image-duplicate');
        this.hiddenSaveDuplicates.add(duplicate);
      });
      this.syncWishlistButton(entry);
      this.reserveImageSave(labelHost,photo);
    }
    arrangeCoupon(card) {
      const hasOffer = [...card.querySelectorAll('wjd-coupon-price')].some(node => !node.closest('.wjd-grid-coupon'));
      if (hasOffer && this.publicationDates.get(card)?.source === card.getAttribute('data-product')) return;
      const price = card.querySelector('.boost-sd__product-price-wrapper,.boost-sd__product-price');
      const link = card.querySelector('.wjd-card-title-row a[href*="/products/"]') || card.querySelector('a[href*="/products/"]');
      if (!price || !link) return;
      let url,handle;
      try {
        const source = new URL(link.getAttribute('href'),location.origin);
        if (source.origin !== location.origin) return;
        handle = decodeURIComponent(source.pathname.split('/products/')[1]?.split('/')[0] || '');
        if (!handle) return;
        url = new URL(source.pathname,location.origin);
        const variant = source.searchParams.get('variant');
        if (variant && /^\d+$/.test(variant)) url.searchParams.set('variant',variant);
        url.searchParams.set('view','wjd-grid-offer');
      } catch { return; }
      const key = url.href + '\n' + price.textContent.trim();
      const previous = this.couponCards.get(card);
      if (previous?.key === key && previous.mount.isConnected) {
        previous.source = card.getAttribute('data-product');
        if (previous.mount.previousElementSibling !== price) price.after(previous.mount);
        return;
      }
      if (previous) { previous.mount.remove(); this.couponObserver?.unobserve(card); }
      const mount = card.querySelector('.wjd-grid-coupon') || document.createElement('div');
      mount.className = 'wjd-grid-coupon'; mount.hidden = true; mount.replaceChildren();
      price.after(mount);
      const entry = {card,mount,url:url.href,handle,key,source:card.getAttribute('data-product')};
      this.couponCards.set(card,entry);
      if (this.couponObserver) this.couponObserver.observe(card);
      else this.queueCoupon(entry);
    }
    queueCoupon(entry) {
      if (!this.events || entry.requested || this.couponCards.get(entry.card) !== entry) return;
      entry.requested = true; this.couponTasks.push(entry); this.runCouponTasks();
    }
    runCouponTasks() {
      const session = this.events;
      while (session && this.couponActive < 3 && this.couponTasks.length) {
        const entry = this.couponTasks.shift();
        if (!entry.card.isConnected || this.couponCards.get(entry.card) !== entry) continue;
        this.couponActive++;
        this.loadCoupon(entry,session).finally(() => {
          if (this.events !== session) return;
          this.couponActive--; this.runCouponTasks();
        });
      }
    }
    async loadCoupon(entry,session) {
      try {
        let request = this.couponCache.get(entry.key);
        if (!request) {
          // Use the same Liquid eligibility and offer selection as product
          // pages. Only cards approaching the viewport request this fragment.
          request = fetch(entry.url,{credentials:'same-origin',cache:'no-store',signal:session.signal}).then(response => {
            if (!response.ok) throw new Error('Coupon view unavailable');
            return response.text();
          }).then(html => {
            const document = new DOMParser().parseFromString(html,'text/html');
            const root = document.querySelector('[data-wjd-grid-offer]');
            if (!root || root.dataset.productHandle !== entry.handle) throw new Error('Coupon view unavailable');
            const result = {published:this.published(root.dataset.published),html:''};
            if (root.dataset.currency !== this.dataset.currency) return result;
            const offer = root.querySelector('wjd-coupon-price');
            if (!offer) return result;
            offer.classList.remove('wjd-coupon-price--product');
            offer.classList.add('wjd-coupon-price--grid');
            offer.querySelector('[data-wjd-offer-label]')?.removeAttribute('hidden');
            offer.querySelectorAll('[data-wjd-offer-open],[data-wjd-offer-fallback],dialog').forEach(node => node.remove());
            result.html = offer.outerHTML;
            return result;
          }).catch(error => { this.couponCache.delete(entry.key); throw error; });
          this.couponCache.set(entry.key,request);
          if (this.couponCache.size > 120) this.couponCache.delete(this.couponCache.keys().next().value);
        }
        const result = await request;
        if (this.events !== session || !entry.card.isConnected || this.couponCards.get(entry.card) !== entry) return;

if (entry.source !== entry.card.getAttribute('data-product')) {
  throw new Error('Coupon card changed');
}
        if (Number.isFinite(result.published)) {
          this.publicationDates.set(entry.card,{source:entry.source,published:result.published});
          this.queue(entry.card);
        }
        const html = result.html;
        if (!html || [...entry.card.querySelectorAll('wjd-coupon-price')].some(node => !node.closest('.wjd-grid-coupon'))) return;
        const template = document.createElement('template'); template.innerHTML = html;
        entry.mount.replaceChildren(template.content.cloneNode(true)); entry.mount.hidden = false;
      } catch (error) {
  if (
    error.name === 'AbortError' ||
    session.signal.aborted ||
    this.events !== session ||
    !entry.card.isConnected ||
    this.couponCards.get(entry.card) !== entry
  ) return;

  this.couponCache.delete(entry.key);
  entry.retries = (entry.retries || 0) + 1;

  if (entry.retries > 2) {
    console.warn('WJD grid coupon could not load', error);
    return;
  }

  setTimeout(() => {
    if (
      session.signal.aborted ||
      this.events !== session ||
      !entry.card.isConnected ||
      this.couponCards.get(entry.card) !== entry
    ) return;

    entry.requested = false;
    this.arrangeCoupon(entry.card);

    if (this.couponCards.get(entry.card) === entry) {
      this.queueCoupon(entry);
    }
  }, 750 * entry.retries);
}
    }
    wishlistProduct(entry) {
      const scope = entry.scope;
      let url = scope.matches('product-info') ? scope.dataset.url : '';
      url ||= scope.querySelector('a[href*="/products/"]')?.getAttribute('href');
      let handle = '';
      try { handle = decodeURIComponent(new URL(url,location.origin).pathname.split('/products/')[1]?.split('/')[0] || ''); } catch {}
      let variantId = scope.matches('product-info') ? scope.querySelector('product-form [name="id"]')?.value : '';
      if (!variantId && url) { try { variantId = new URL(url,location.origin).searchParams.get('variant'); } catch {} }
      return {handle,variantId:variantId ? Number(variantId) : undefined};
    }
    async wishlistApp() {
      if (!this.appPromise) this.appPromise = (async () => {
        if (window.WishlistKing?.addWishlistItem) return window.WishlistKing;
        // The speed optimizer can delay Swish's inline bootstrap. Reuse its
        // rendered extension URL and import the existing app module once.
        const bootstrap = [...document.scripts].find(script => script.textContent.includes('window.WishlistKingAppLoaderURL ='));
        const source = window.WishlistKingAppLoaderURL || bootstrap?.textContent.match(/WishlistKingAppLoaderURL\s*=\s*["']([^"']+)["']/)?.[1];
        if (!source) throw new Error('Wishlist app unavailable');
        const url = new URL(source,location.origin);
        if (url.protocol !== 'https:' || url.hostname !== 'cdn.shopify.com' || !url.pathname.includes('/swish-wishlist-king-')) throw new Error('Wishlist app unavailable');
        window.WishlistKingAppLoaderURL = source;
        const {default:loader} = await import(source);
        await import(new URL('block-app-settings.js',source).href);
        const base = new URL('.',source).href;
        const modules = [...document.scripts].map(script => script.getAttribute('src') || script.getAttribute('data-src')).filter(value => value?.startsWith(base) && /\/block-[a-z-]+\.js$/.test(value));
        await Promise.all([...new Set(modules)].map(value => import(value)));
        const module = await loader.waitForCore('wishlist-app');
        if (!module?.artifact?.addWishlistItem) throw new Error('Wishlist app unavailable');
        return module.artifact;
      })().catch(error => { this.appPromise = null; throw error; });
      let timer;
      try { return await Promise.race([this.appPromise,new Promise((_,reject) => { timer=setTimeout(() => reject(new Error('Wishlist unavailable')),10000); })]); }
      finally { clearTimeout(timer); }
    }
    scheduleWishlistRefresh() {
      if (!this.events) return;
      clearTimeout(this.wishlistTimer);
      this.wishlistTimer = setTimeout(() => this.refreshWishlist(),180);
    }
    async refreshWishlist() {
      if (!this.events || !this.savedButtons.size || this.wishlistWorking) return;
      return this.readWishlist();
    }
    async readWishlist() {
      if (this.wishlistReading) return this.wishlistReading;
      const session = this.events, version = this.wishlistVersion;
      const reading = (async () => {
        try {
          const app = await this.wishlistApp();
          const result = await app.apis.wishlist.loadWishlist({wishlistId:'mine',cacheStrategy:'no-store'});
          if (this.events !== session) return false;
          // A read started before a successful write must not undo that write.
          if (this.wishlistVersion !== version) { this.scheduleWishlistRefresh(); return false; }
          this.wishlistItems = result.wishlist.items || [];
          this.wishlistMode = app.settings.general.wishlistMode;
          this.syncWishlistButtons();
          return true;
        } catch (error) { console.warn('WJD wishlist could not load',error); return false; }
      })();
      this.wishlistReading = reading;
      try { return await reading; }
      finally { if (this.wishlistReading === reading) this.wishlistReading = null; }
    }
    wishlistMatches(first,second) {
      return first.handle === second.handle && (this.wishlistMode !== 'VARIANT' || !second.variantId || Number(first.variantId) === Number(second.variantId));
    }
    wishlistItem(product) {
      return this.wishlistItems?.find(item => this.wishlistMatches({handle:item.product.handle,variantId:item.variantId},product));
    }
    wishlistIntent(product) {
      return this.wishlistIntents?.find(intent => this.wishlistMatches(intent.product,product));
    }
    syncWishlistButton(entry) {
      const product = this.wishlistProduct(entry);
      const intent = this.wishlistIntent(product);
      const saved = intent ? intent.desired : Boolean(this.wishlistItem(product));
      const set = (name,value) => { if (entry.button.getAttribute(name) !== value) entry.button.setAttribute(name,value); };
      if (this.wishlistItems || intent) set('aria-pressed',String(saved));
      set('aria-label',saved ? this.dataset.removeLabel : this.dataset.saveLabel);
      entry.button.disabled = !product.handle;
      if (intent) set('aria-busy','true');
      else entry.button.removeAttribute('aria-busy');
    }
    syncWishlistButtons() { this.savedButtons?.forEach(entry => this.syncWishlistButton(entry)); }
    toggleWishlist(button) {
      const entry = [...this.savedButtons.values()].find(item => item.button === button);
      if (!entry) return;
      const product = this.wishlistProduct(entry);
      if (!product.handle) return;
      const intent = this.wishlistIntent(product);
      const desired = !(intent ? intent.desired : Boolean(this.wishlistItem(product)));
      if (intent) { intent.desired = desired; intent.product = product; }
      else this.wishlistIntents.push({product,desired});
      this.savedButtons.forEach(item => {
        if (!this.wishlistMatches(this.wishlistProduct(item),product)) return;
        item.feedback.hidden = true; item.feedback.textContent = '';
      });
      // Paint the latest choice in the same click, before any network work.
      this.syncWishlistButtons();
      this.animateSavedHeart(button,desired);
      this.flushWishlist();
    }
    animateSavedHeart(button, saved) {
      this.saveMotions.get(button)?.cancel();
      this.saveMotions.delete(button);
      if (!saved || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const icon = button.querySelector('.bi-heart-fill');
      if (typeof icon?.animate !== 'function') return;
      try {
        icon.style.transformOrigin = 'center';
        const motion = icon.animate([
          {transform:'translateY(0) scale(1)',fill:'#e44747',offset:0,easing:'cubic-bezier(.4,0,.6,1)'},
          {transform:'translateY(2px) scale(1.12,.82)',fill:'#e44747',offset:.105,easing:'cubic-bezier(.16,1,.3,1)'},
          {transform:'translateY(-12px) scale(.96,1.16) rotate(-8deg)',fill:'#e44747',offset:.3225,easing:'cubic-bezier(.55,.05,.85,.5)'},
          {transform:'translateY(1px) scale(1.15,.86) rotate(3deg)',fill:'#d94545',offset:.54,easing:'cubic-bezier(.16,1,.3,1)'},
          {transform:'translateY(-3px) scale(.98,1.04)',fill:'#a83a3a',offset:.6525,easing:'ease-in-out'},
          {transform:'translateY(0) scale(1) rotate(0deg)',fill:'#783232',offset:.75},
          {transform:'translateY(0) scale(1) rotate(0deg)',fill:'#222222',offset:1}
        ],{duration:960,easing:'linear'});
        this.saveMotions.set(button,motion);
        const done = () => { if (this.saveMotions.get(button)===motion) this.saveMotions.delete(button); };
        motion.finished.then(done,done);
      } catch {}
    }
    async writeWishlist(app,product,item,session) {
      const deadline = performance.now() + 8000;
      while (this.events === session) {
        const result = item ? await app.removeWishlistItem({wishlistItemId:item.id}) : await app.addWishlistItem({productHandle:product.handle,variantId:product.variantId});
        if (result?.wishlistItem?.id) return result.wishlistItem;
        // Swish returns undefined, without making a request, while its previous
        // update is settling. Only that no-op is safe to try again.
        if (result !== undefined || performance.now() >= deadline) throw new Error('Wishlist update unavailable');
        await new Promise(resolve => setTimeout(resolve,100));
      }
      throw new Error('Wishlist disconnected');
    }
    failWishlist(intent,error) {
      console.warn('WJD wishlist could not update',error);
      this.wishlistIntents = this.wishlistIntents.filter(item => item !== intent);
      this.savedButtons.forEach(entry => {
        if (!this.wishlistMatches(this.wishlistProduct(entry),intent.product)) return;
        entry.feedback.textContent = this.dataset.errorLabel; entry.feedback.hidden = false;
      });
    }
    async flushWishlist() {
      if (this.wishlistWorking || !this.events) return;
      this.wishlistWorking = true;
      const session = this.events;
      try {
        const app = await this.wishlistApp();
        this.wishlistMode = app.settings.general.wishlistMode;
        if (this.events !== session) return;
        if (!this.wishlistItems && !await this.readWishlist()) throw new Error('Wishlist unavailable');
        while (this.events === session && this.wishlistIntents.length) {
          const intent = this.wishlistIntents[0];
          const product = {...intent.product}, item = this.wishlistItem(product);
          if (intent.desired === Boolean(item)) { this.wishlistIntents.shift(); this.syncWishlistButtons(); continue; }
          try {
            const saved = await this.writeWishlist(app,product,item,session);
            if (this.events !== session) return;
            if (item) this.wishlistItems = this.wishlistItems.filter(value => value.id !== item.id);
            else this.wishlistItems.push({id:saved.id,variantId:saved.variantId ?? product.variantId,product:{id:saved.productId,handle:product.handle}});
            this.wishlistVersion++;
            // Leave a changed intent queued so a second tap wins, even if the
            // first request was already in flight.
            if (intent.desired === Boolean(this.wishlistItem(intent.product))) this.wishlistIntents.shift();
          } catch (error) {
            if (this.events !== session) return;
            this.failWishlist(intent,error);
          }
          this.syncWishlistButtons();
        }
      } catch (error) {
        if (this.events !== session) return;
        [...this.wishlistIntents].forEach(intent => this.failWishlist(intent,error));
      } finally {
        if (this.events === session) {
          this.wishlistWorking = false; this.syncWishlistButtons(); this.scheduleWishlistRefresh();
        }
      }
    }
    restoreSaveButtons() {
      this.savedButtons?.forEach(entry => {
        const badge = entry.host.querySelector('.wjd-product-deal');
        if (badge && entry.host.parentElement) { badge.classList.remove('wjd-product-deal'); entry.host.after(badge); }
        entry.host.classList.remove('wjd-save-host'); entry.button.remove(); entry.feedback.remove();
      });
      this.hiddenSaveDuplicates?.forEach(button => button.classList.remove('wjd-save-image-duplicate'));
      this.clearedPhotos?.forEach(photo => photo.classList.remove('wjd-save-photo-cleared'));
      this.imageFallbacks?.forEach(host => host.style.removeProperty('--wjd-new-label-end'));
      this.savedButtons?.clear(); this.hiddenSaveDuplicates?.clear();
      this.clearedPhotos?.clear(); this.imageFallbacks?.clear();
      this.titleRows?.forEach((title,row) => {
        title.removeAttribute('data-wjd-save-title');
        row.querySelectorAll('[data-wjd-full-title]').forEach(node => node.removeAttribute('data-wjd-full-title'));
        if (row.parentElement && title.parentElement === row) row.replaceWith(title);
      });
      this.titleRows?.clear();
    }
    scheduleExpiry() {
      clearTimeout(this.expiry);
      if (!this.owned.size) return;
      const next = Math.min(...[...this.owned.values()].map(entry => entry.published + 30 * 86400000));
      this.expiry = setTimeout(() => {
        for (const card of this.owned.keys()) this.queue(card);
      }, Math.min(86400000, Math.max(1000, next - this.now() + 50)));
    }
    disconnectedCallback() {
      this.saveMotions?.forEach(motion => motion.cancel()); this.saveMotions?.clear();
      this.events?.abort(); this.observer?.disconnect();
      this.fireObserver?.disconnect();
      document.documentElement.removeAttribute('data-wjd-fire-paused');
      this.couponObserver?.disconnect(); this.couponTasks = [];
      this.couponCards?.forEach(entry => entry.mount.remove());
      this.couponCards?.clear(); this.couponCache?.clear();
      this.wishlistIntents = [];
      clearTimeout(this.expiry); clearTimeout(this.wishlistTimer); cancelAnimationFrame(this.frame);
      this.frame = null; this.pending?.clear();
      this.owned?.forEach(entry => { entry.label.remove(); entry.host.classList.remove('wjd-new-label-host'); });
      this.owned?.clear(); this.restoreSaveButtons(); this.events = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wjd-piece-story"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wjd-piece-story')) {
  customElements.define('wjd-piece-story', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      if (!this.hasAttribute('data-wjd-entered') && !matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
        this.enterObserver = new IntersectionObserver(entries => {
          if (!this.isConnected || !entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= .2)) return;
          this.setAttribute('data-wjd-entered', '');
          this.enterObserver.disconnect();
        }, { threshold: .2 });
        this.enterObserver.observe(this);
      }
      const button = this.querySelector('button');
      if (!button) return;
      let messages;
      try { messages = JSON.parse(this.querySelector('script').textContent); } catch { return; }
      if (!Array.isArray(messages)) return;
      messages = messages.filter(item => item && typeof item.content === 'string' && item.content.trim());
      if (!messages.length) return;
      const front = this.querySelector('.wjd-piece-story__front');
      const back = this.querySelector('.wjd-piece-story__back');
      let previous = -1;
      const reset = () => {
        button.setAttribute('aria-pressed', 'false');
        front.setAttribute('aria-hidden', 'false');
        back.setAttribute('aria-hidden', 'true');
      };
      this.resetReveal = reset;
      reset();
      button.hidden = false;
      button.addEventListener('click', () => {
        clearTimeout(this.timer);
        if (button.getAttribute('aria-pressed') === 'true') { reset(); return; }
        let index = Math.floor(Math.random() * messages.length);
        if (messages.length > 1 && index === previous) index = (index + 1) % messages.length;
        previous = index;
        back.textContent = messages[index].content;
        front.setAttribute('aria-hidden', 'true');
        back.setAttribute('aria-hidden', 'false');
        button.setAttribute('aria-pressed', 'true');
        this.timer = setTimeout(reset, 6000);
      }, { signal: this.events.signal });
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.enterObserver?.disconnect();
      this.events?.abort();
      this.events = null;
      this.resetReveal?.();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wjd-promotion"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',async(event)=>{
 const button=event.target.closest('[data-wjd-copy]'); if(!button)return;
 try{await navigator.clipboard.writeText(button.dataset.wjdCopy);const label=button.querySelector('span');const old=label.textContent;label.textContent=button.dataset.copied;setTimeout(()=>{label.textContent=old},2500)}catch(e){button.querySelector('span').textContent=button.dataset.wjdCopy;}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wjd-quick-answers"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wjd-quick-answers')) {
  class WjdQuickAnswers extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.buttons = [];
      this.panel = this.querySelector('.wjd-qa-panel');
      this.answer = this.querySelector('.wjd-qa-answer');
      const chips = this.querySelector('.wjd-qa-chips');
      chips.after(this.panel);

      this.querySelectorAll('details[data-answer]').forEach(details => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'wjd-qa-chip';
        button.textContent = details.querySelector('summary').textContent;
        button.id = this.id + '-' + details.dataset.answer;
        button.setAttribute('aria-expanded', 'false');
        button.setAttribute('aria-controls', this.id + '-panel');

        button.addEventListener('click', () => {
          const opening = button.getAttribute('aria-expanded') !== 'true';

          this.buttons.forEach(item =>
            item.setAttribute(
              'aria-expanded',
              String(item === button && opening)
            )
          );

          this.activeButton = button;

          if (opening) {
            this.answer.setAttribute('aria-labelledby', button.id);
          }

          this.transitionPanel(
            opening,
            opening
              ? details.querySelector('.wjd-qa-copy').cloneNode(true)
              : null
          );
        });

        this.buttons.push(button);
        chips.append(button);
      });

      this.panel.id = this.id + '-panel';
      this.querySelector('.wjd-qa-fallback').hidden = true;
      chips.hidden = false;

      this.querySelector('.wjd-qa-close').addEventListener(
        'click',
        () => this.close()
      );

      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !this.panel.hidden) this.close();
      });

      if (
        typeof subscribe === 'function' &&
        typeof PUB_SUB_EVENTS !== 'undefined'
      ) {
        this.unsubscribe = subscribe(
          PUB_SUB_EVENTS.variantChange,
          ({ data }) => {
            if (String(data.sectionId) !== this.dataset.section) return;
            const fresh = data.html?.getElementById(this.id);
            if (fresh) this.replaceWith(fresh.cloneNode(true));
            else this.remove();
          }
        );
      }
    }

    transitionPanel(opening, content) {
      const from = this.panel.hidden
        ? 0
        : this.panel.getBoundingClientRect().height;

      this.panel.style.height = from + 'px';
      this.animation?.cancel();
      this.panel.hidden = false;
      this.panel.inert = !opening;

      if (content) this.answer.replaceChildren(content);

      this.panel.style.height = 'auto';
      const target = opening
        ? this.panel.getBoundingClientRect().height
        : 0;

      this.panel.style.height = from + 'px';
      this.panel.style.overflow = 'hidden';

      const finish = () => {
        this.panel.hidden = !opening;
        this.panel.style.removeProperty('height');
        this.panel.style.removeProperty('overflow');
        if (!opening) this.answer.replaceChildren();
      };

      if (
        matchMedia('(prefers-reduced-motion: reduce)').matches ||
        !this.panel.animate
      ) {
        finish();
        return;
      }

      this.animation = this.panel.animate(
        [
          {
            height: from + 'px',
            opacity: from ? 1 : 0,
            marginTop: from ? '10px' : '0px'
          },
          {
            height: target + 'px',
            opacity: opening ? 1 : 0,
            marginTop: opening ? '10px' : '0px'
          }
        ],
        {
          duration: 220,
          easing: 'cubic-bezier(.2,.7,.2,1)'
        }
      );

      this.animation.onfinish = finish;
    }

    close() {
      this.buttons.forEach(button =>
        button.setAttribute('aria-expanded', 'false')
      );
      this.activeButton?.focus({ preventScroll: true });
      this.transitionPanel(false);
    }

    disconnectedCallback() {
      this.unsubscribe?.();
      this.animation?.cancel();
    }
  }

  customElements.define('wjd-quick-answers', WjdQuickAnswers);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wjd-ux-polish"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wjd-ux-polish')) {
  customElements.define('wjd-ux-polish',class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events=new AbortController();
      const signal=this.events.signal;
      this.panels=new Map();this.openPanels=new Set();this.stories=new Map();
      this.mobile=matchMedia('(max-width:749px)');this.reduced=matchMedia('(prefers-reduced-motion:reduce)');
      document.addEventListener('click',event=>this.policyClick(event),{capture:true,signal});
      this.scanStories(document);
      document.addEventListener('shopify:section:load',event=>this.scanStories(event.target),{signal});
      this.mobile.addEventListener('change',()=>{if(!this.mobile.matches)this.stories.forEach(entry=>this.cancelStory(entry));},{signal});
      this.reduced.addEventListener('change',()=>{if(this.reduced.matches)this.stories.forEach(entry=>this.cancelStory(entry));},{signal});
      document.addEventListener('visibilitychange',()=>{if(document.hidden)this.stories.forEach(entry=>this.cancelStory(entry));},{signal});
      window.addEventListener('pagehide',()=>this.stories.forEach(entry=>this.cancelStory(entry)),{signal});
    }
    policyClick(event) {
      const trigger=event.target.closest?.('[popovertarget]');
      if (!trigger) return;
      const panel=document.getElementById(trigger.getAttribute('popovertarget'));
      if (!panel || !panel.matches('.wjd-policy-panel') || typeof HTMLDialogElement==='undefined') return;
      event.preventDefault();event.stopImmediatePropagation();
      let entry=this.panels.get(panel);
      if (!entry) entry=this.wrapPolicy(panel);
      if (trigger.getAttribute('popovertargetaction')==='hide' || entry.shell.open) {entry.shell.close();return;}
      entry.opener=trigger;trigger.setAttribute('aria-expanded','true');
      entry.shell.showModal();this.openPanels.add(entry);
      document.documentElement.classList.add('wjd-polish-modal-open');
      this.watchOpenPanels();
    }
    wrapPolicy(panel) {
      const shell=document.createElement('dialog');shell.className='wjd-overlay-shell';
      const label=panel.getAttribute('aria-labelledby');
      if(label)shell.setAttribute('aria-labelledby',label);
      else if(panel.getAttribute('aria-label'))shell.setAttribute('aria-label',panel.getAttribute('aria-label'));
      const entry={panel,shell,popover:panel.getAttribute('popover'),role:panel.getAttribute('role')};
      panel.before(shell);shell.append(panel);
      if(panel.matches(':popover-open'))panel.hidePopover();
      panel.removeAttribute('popover');panel.removeAttribute('role');
      const signal=this.events.signal;
      shell.addEventListener('pointerdown',event=>{entry.outsideDown=event.target===shell;},{signal});
      shell.addEventListener('click',event=>{
        if(event.target===shell && entry.outsideDown){event.preventDefault();event.stopImmediatePropagation();shell.close();}
      },{signal});
      shell.addEventListener('close',()=>{
        this.openPanels.delete(entry);entry.opener?.setAttribute('aria-expanded','false');
        this.unlockPanels();
        if(entry.opener?.isConnected)entry.opener.focus({preventScroll:true});
      },{signal});
      this.panels.set(panel,entry);return entry;
    }
    watchOpenPanels() {
      if(this.panelObserver)return;
      this.panelObserver=new MutationObserver(()=>{
        this.openPanels.forEach(entry=>{if(!entry.shell.isConnected){this.openPanels.delete(entry);this.panels.delete(entry.panel);}});
        this.unlockPanels();
      });
      this.panelObserver.observe(document.body,{childList:true,subtree:true});
    }
    unlockPanels() {
      if(this.openPanels.size)return;
      document.documentElement.classList.remove('wjd-polish-modal-open');
      this.panelObserver?.disconnect();this.panelObserver=null;
    }
    scanStories(root) {
      const galleries=[...(root.querySelectorAll?.('.wjd-design-story__gallery')||[])];
      if(root.matches?.('.wjd-design-story__gallery'))galleries.unshift(root);
      galleries.forEach(gallery=>{
        if(this.stories.has(gallery)||gallery.children.length<2)return;
        const entry={gallery,seen:false,frame:0};this.stories.set(gallery,entry);
        const signal=this.events.signal;
        ['pointerdown','touchstart','wheel','keydown','focusin'].forEach(name=>gallery.addEventListener(name,()=>{entry.seen=true;this.cancelStory(entry);},{passive:name!=='keydown',signal}));
        if('IntersectionObserver' in window){
          entry.observer=new IntersectionObserver(items=>{
            if(items.some(item=>item.isIntersecting&&item.intersectionRatio>=.35))this.introduceStory(entry);
          },{threshold:.35});
          entry.observer.observe(gallery);
        }
      });
    }
    introduceStory(entry) {
      const gallery=entry.gallery;
      if(entry.seen || !this.isConnected || !gallery.isConnected || document.hidden || !this.mobile.matches || this.reduced.matches || gallery.contains(document.activeElement))return;
      const max=gallery.scrollWidth-gallery.clientWidth;
      if(max<24 || Math.abs(gallery.scrollLeft)>1)return;
      entry.seen=true;entry.observer?.disconnect();
      entry.saved=['scroll-snap-type','scroll-behavior'].map(name=>[name,gallery.style.getPropertyValue(name),gallery.style.getPropertyPriority(name)]);
      gallery.style.setProperty('scroll-snap-type','none','important');gallery.style.setProperty('scroll-behavior','auto','important');
      const direction=getComputedStyle(gallery).direction==='rtl'?-1:1;
      const distance=direction*max;const duration=Math.min(1100,Math.max(750,max*.6));
      gallery.scrollLeft=distance;let started;
      const tick=time=>{
        if(!this.isConnected||!gallery.isConnected||document.hidden||!this.mobile.matches||this.reduced.matches){this.cancelStory(entry);return;}
        started??=time;const progress=Math.min(1,(time-started)/duration);const ease=1-Math.pow(1-progress,3);
        gallery.scrollLeft=distance*(1-ease);
        if(progress<1)entry.frame=requestAnimationFrame(tick);
        else {gallery.scrollLeft=0;this.cancelStory(entry);}
      };
      entry.frame=requestAnimationFrame(tick);
    }
    cancelStory(entry) {
      cancelAnimationFrame(entry.frame);entry.frame=0;
      if(entry.seen)entry.observer?.disconnect();
      entry.saved?.forEach(([name,value,priority])=>value?entry.gallery.style.setProperty(name,value,priority):entry.gallery.style.removeProperty(name));
      entry.saved=null;
    }
    disconnectedCallback() {
      this.stories?.forEach(entry=>{this.cancelStory(entry);entry.observer?.disconnect();});this.stories?.clear();
      this.openPanels?.forEach(entry=>entry.shell.close());this.openPanels?.clear();this.unlockPanels();
      this.panels?.forEach(entry=>{
        if(entry.shell.isConnected){entry.shell.before(entry.panel);entry.shell.remove();entry.panel.setAttribute('popover',entry.popover??'');if(entry.role)entry.panel.setAttribute('role',entry.role);}
      });
      this.panels?.clear();this.events?.abort();this.events=null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wjd-watch-buy-test"] && !Shopify.designMode) return;
  try {
    if (!window.wjdDetailsMotionReady) {
  window.wjdDetailsMotionReady = true;
  const active = new WeakMap();
  document.addEventListener('click', (event) => {
    const summary = event.target.closest('.wjd-full-description > summary');
    if (!summary || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    event.preventDefault();
    const details = summary.parentElement;
    const excerpt = details.closest('.wjd-about-card').querySelector('.wjd-about-excerpt');
    const running = active.get(details);
    const opening = running ? !running.opening : !details.open;
    const start = details.getBoundingClientRect().height;
    const excerptStart = excerpt ? {
      height: getComputedStyle(excerpt).height,
      marginBottom: getComputedStyle(excerpt).marginBottom,
      opacity: getComputedStyle(excerpt).opacity
    } : null;
    if (running) running.animations.forEach(animation => animation.cancel());
    details.open = false;
    const collapsed = details.getBoundingClientRect().height;
    const excerptEnd = excerpt ? {
      height: opening ? '0px' : getComputedStyle(excerpt).height,
      marginBottom: opening ? '0px' : getComputedStyle(excerpt).marginBottom,
      opacity: opening ? 0 : 1
    } : null;
    details.open = true;
    const expanded = details.getBoundingClientRect().height;
    details.style.overflow = 'hidden';
    const timing = {duration: 340, easing: 'cubic-bezier(.22,1,.36,1)'};
    const animation = details.animate(
      [{height: start + 'px'}, {height: (opening ? expanded : collapsed) + 'px'}], timing);
    const animations = [animation];
    if (excerpt) animations.push(excerpt.animate([excerptStart, excerptEnd], {...timing, fill: 'forwards'}));
    active.set(details, {animations, opening});
    animation.onfinish = () => {
      details.open = opening;
      details.style.overflow = '';
      animations.forEach(item => item.cancel());
      active.delete(details);
    };
  });
}

if (!customElements.get('wjd-purchase-details')) {
  class WjdPurchaseDetails extends HTMLElement {
    connectedCallback() {
      if (this.unsubscribe || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({data}) => {
        if (String(data.sectionId) !== this.dataset.section) return;
        const fresh = data.html?.getElementById(this.id)?.querySelector('.wjd-buy-summary');
        const current = this.querySelector('.wjd-buy-summary');
        if (fresh && current) current.replaceWith(fresh.cloneNode(true));
        else if (current && !fresh) current.remove();
        else if (fresh) this.querySelector('.wjd-full-description')?.before(fresh.cloneNode(true));
      });
    }
    disconnectedCallback() { this.unsubscribe?.(); }
  }
  customElements.define('wjd-purchase-details', WjdPurchaseDetails);
}
  } catch(e) { console.error(e); }
})();

})();
